/** Auto-generated from ingredients/catalog.json — do not edit by hand. */
export function normalizeIngredientName(name: string): string {
  return name.trim().toLowerCase();
}

/** Normalized ingredient name/synonym → catalog id. */
export const INGREDIENT_NAME_TO_ID: Record<string, string> = {
  "potato": "potato",
  "aloo": "potato",
  "alu": "potato",
  "batata": "potato",
  "urulai": "potato",
  "urulaikizhangu": "potato",
  "bangaladumpa": "potato",
  "potatoes": "potato",
  "onion": "onion",
  "pyaz": "onion",
  "pyaaz": "onion",
  "kanda": "onion",
  "ulli": "onion",
  "vengayam": "onion",
  "neerulli": "onion",
  "ullipaya": "onion",
  "red onion": "onion",
  "onions": "onion",
  "spring onion": "spring_onion",
  "scallion": "spring_onion",
  "scallions": "spring_onion",
  "green onion": "spring_onion",
  "salad onion": "spring_onion",
  "hara pyaz": "spring_onion",
  "spring onions": "spring_onion",
  "shallot": "shallot",
  "sambar onion": "shallot",
  "small onion": "shallot",
  "madras onion": "shallot",
  "pearl onion": "shallot",
  "chinna vengayam": "shallot",
  "chuvanna ulli": "shallot",
  "shallots": "shallot",
  "kunda pyaz": "shallot",
  "tomato": "tomato",
  "tamatar": "tomato",
  "tomatto": "tomato",
  "thakkali": "tomato",
  "tamota": "tomato",
  "tomato red": "tomato",
  "tomatoes": "tomato",
  "garlic": "garlic",
  "lehsun": "garlic",
  "lasun": "garlic",
  "lahsun": "garlic",
  "vellulli": "garlic",
  "poondu": "garlic",
  "bellulli": "garlic",
  "garlic cloves": "garlic",
  "garlic pod": "garlic",
  "ginger": "ginger",
  "adrak": "ginger",
  "aale": "ginger",
  "inji": "ginger",
  "shunti": "ginger",
  "allam": "ginger",
  "fresh ginger": "ginger",
  "ginger root": "ginger",
  "green chilli": "green_chilli",
  "hari mirch": "green_chilli",
  "mirchi": "green_chilli",
  "pachai milagai": "green_chilli",
  "hasi menasinakai": "green_chilli",
  "pachi mirapakaya": "green_chilli",
  "green chillies": "green_chilli",
  "green chili": "green_chilli",
  "chilly": "green_chilli",
  "chilli": "green_chilli",
  "carrot": "carrot",
  "gajar": "carrot",
  "carot": "carrot",
  "carrots": "carrot",
  "carrat": "carrot",
  "mullangi carrot": "carrot",
  "beetroot": "beetroot",
  "chukandar": "beetroot",
  "beet": "beetroot",
  "beets": "beetroot",
  "beet root": "beetroot",
  "radish": "radish",
  "mooli": "radish",
  "muli": "radish",
  "mullangi": "radish",
  "daikon": "radish",
  "white radish": "radish",
  "cauliflower": "cauliflower",
  "phool gobi": "cauliflower",
  "phulgobi": "cauliflower",
  "gobi": "cauliflower",
  "gobhi": "cauliflower",
  "cauli flower": "cauliflower",
  "hookosu": "cauliflower",
  "cabbage": "cabbage",
  "patta gobi": "cabbage",
  "band gobi": "cabbage",
  "muttaikose": "cabbage",
  "cabage": "cabbage",
  "kosu": "cabbage",
  "broccoli": "broccoli",
  "hari gobi": "broccoli",
  "brocoli": "broccoli",
  "brocolli": "broccoli",
  "capsicum": "capsicum",
  "bell pepper": "capsicum",
  "shimla mirch": "capsicum",
  "green pepper": "capsicum",
  "sweet pepper": "capsicum",
  "capsicum bell": "capsicum",
  "paprika pepper": "capsicum",
  "bell peppers": "capsicum",
  "brinjal": "brinjal",
  "eggplant": "brinjal",
  "aubergine": "brinjal",
  "baingan": "brinjal",
  "begun": "brinjal",
  "vankaya": "brinjal",
  "kathirikai": "brinjal",
  "badanekai": "brinjal",
  "brinjals": "brinjal",
  "okra": "okra",
  "lady finger": "okra",
  "ladies finger": "okra",
  "bhindi": "okra",
  "bhendi": "okra",
  "vendakai": "okra",
  "bende kai": "okra",
  "bendekayi": "okra",
  "okhra": "okra",
  "ladyfinger": "okra",
  "bottle gourd": "bottle_gourd",
  "lauki": "bottle_gourd",
  "ghiya": "bottle_gourd",
  "doodhi": "bottle_gourd",
  "sorakkai": "bottle_gourd",
  "sorekai": "bottle_gourd",
  "anapakaya": "bottle_gourd",
  "calabash": "bottle_gourd",
  "opo squash": "bottle_gourd",
  "ridge gourd": "ridge_gourd",
  "turai": "ridge_gourd",
  "tori": "ridge_gourd",
  "peerkangai": "ridge_gourd",
  "heerekai": "ridge_gourd",
  "beerakaya": "ridge_gourd",
  "luffa": "ridge_gourd",
  "ridged gourd": "ridge_gourd",
  "bitter gourd": "bitter_gourd",
  "karela": "bitter_gourd",
  "pavakkai": "bitter_gourd",
  "hagalakai": "bitter_gourd",
  "kakarakaya": "bitter_gourd",
  "bitter melon": "bitter_gourd",
  "snake gourd": "snake_gourd",
  "chichinda": "snake_gourd",
  "pudalangai": "snake_gourd",
  "padavalakai": "snake_gourd",
  "potlakaya": "snake_gourd",
  "ash gourd": "ash_gourd",
  "petha": "ash_gourd",
  "winter melon": "ash_gourd",
  "white pumpkin": "ash_gourd",
  "kumbalakai": "ash_gourd",
  "neer poosanikai": "ash_gourd",
  "boodida gummadikaya": "ash_gourd",
  "pumpkin": "pumpkin",
  "kaddu": "pumpkin",
  "sitaphal pumpkin": "pumpkin",
  "parangikai": "pumpkin",
  "kumbalakai kempu": "pumpkin",
  "gummadikaya": "pumpkin",
  "red pumpkin": "pumpkin",
  "yellow pumpkin": "pumpkin",
  "cucumber": "cucumber",
  "kheera": "cucumber",
  "khira": "cucumber",
  "kakdi": "cucumber",
  "vellarikai": "cucumber",
  "southekai": "cucumber",
  "dosakaya": "cucumber",
  "zucchini": "zucchini",
  "courgette": "zucchini",
  "zuccini": "zucchini",
  "tinda": "tinda",
  "apple gourd": "tinda",
  "indian round gourd": "tinda",
  "round gourd": "tinda",
  "tindora gourd": "tinda",
  "ivy gourd": "tindora",
  "tindora": "tindora",
  "tendli": "tindora",
  "kundru": "tindora",
  "kovakkai": "tindora",
  "tondekai": "tindora",
  "dondakaya": "tindora",
  "gherkin gourd": "tindora",
  "drumstick": "drumstick",
  "moringa": "drumstick",
  "sahjan": "drumstick",
  "munakkada": "drumstick",
  "murungakkai": "drumstick",
  "nuggekai": "drumstick",
  "munaga": "drumstick",
  "raw banana": "raw_banana",
  "green banana": "raw_banana",
  "plantain": "raw_banana",
  "kaccha kela": "raw_banana",
  "vazhakkai": "raw_banana",
  "balekai": "raw_banana",
  "aratikaya": "raw_banana",
  "cooking banana": "raw_banana",
  "raw papaya": "raw_papaya",
  "green papaya": "raw_papaya",
  "kaccha papita": "raw_papaya",
  "pachai pappali": "raw_papaya",
  "raw mango": "raw_mango",
  "kacha aam": "raw_mango",
  "kairi": "raw_mango",
  "mavinakai": "raw_mango",
  "mamidikaya": "raw_mango",
  "manga": "raw_mango",
  "green mango": "raw_mango",
  "green peas": "green_peas",
  "matar": "green_peas",
  "mutter": "green_peas",
  "vatana": "green_peas",
  "pattani": "green_peas",
  "batani": "green_peas",
  "peas": "green_peas",
  "fresh peas": "green_peas",
  "frozen peas": "green_peas",
  "french beans": "french_beans",
  "green beans": "french_beans",
  "fansi": "french_beans",
  "beans": "french_beans",
  "haricot": "french_beans",
  "string beans": "french_beans",
  "huralikai": "french_beans",
  "cluster beans": "cluster_beans",
  "gawar": "cluster_beans",
  "guar": "cluster_beans",
  "kothavarangai": "cluster_beans",
  "goru chikkudu": "cluster_beans",
  "gorikai": "cluster_beans",
  "broad beans": "broad_beans",
  "fava beans": "broad_beans",
  "sem": "broad_beans",
  "papdi": "broad_beans",
  "avarakkai": "broad_beans",
  "chikkudukaya": "broad_beans",
  "averekai": "broad_beans",
  "lima beans": "double_beans",
  "double beans": "double_beans",
  "butter beans": "double_beans",
  "mochai": "double_beans",
  "pavtha": "double_beans",
  "sweet corn": "corn",
  "makka": "corn",
  "bhutta": "corn",
  "makkai": "corn",
  "corn": "corn",
  "maize": "corn",
  "mokkajonna": "corn",
  "makkacholam": "corn",
  "corn kernels": "corn",
  "mushroom": "mushroom",
  "khumbi": "mushroom",
  "kumb": "mushroom",
  "button mushroom": "mushroom",
  "mashroom": "mushroom",
  "mushrooms": "mushroom",
  "spinach": "spinach",
  "palak": "spinach",
  "keerai": "spinach",
  "pasalai keerai": "spinach",
  "palak saag": "spinach",
  "spinach leaves": "spinach",
  "fenugreek leaves": "fenugreek_leaves",
  "methi": "fenugreek_leaves",
  "methi leaves": "fenugreek_leaves",
  "vendhaya keerai": "fenugreek_leaves",
  "menthya soppu": "fenugreek_leaves",
  "kasuri methi fresh": "fenugreek_leaves",
  "amaranth leaves": "amaranth_leaves",
  "chaulai": "amaranth_leaves",
  "thandu keerai": "amaranth_leaves",
  "mulai keerai": "amaranth_leaves",
  "dantu": "amaranth_leaves",
  "harive soppu": "amaranth_leaves",
  "red spinach": "amaranth_leaves",
  "mustard greens": "mustard_greens",
  "sarson": "mustard_greens",
  "sarson ka saag": "mustard_greens",
  "rai greens": "mustard_greens",
  "dill leaves": "dill_leaves",
  "sua": "dill_leaves",
  "soa": "dill_leaves",
  "shepu": "dill_leaves",
  "sabbasige soppu": "dill_leaves",
  "sadakuppi": "dill_leaves",
  "colocasia leaves": "colocasia_leaves",
  "arbi leaves": "colocasia_leaves",
  "patra leaves": "colocasia_leaves",
  "alu leaves": "colocasia_leaves",
  "taro leaves": "colocasia_leaves",
  "moringa leaves": "moringa_leaves",
  "drumstick leaves": "moringa_leaves",
  "murungai keerai": "moringa_leaves",
  "nugge soppu": "moringa_leaves",
  "lettuce": "lettuce",
  "iceberg": "lettuce",
  "romaine": "lettuce",
  "salad leaves": "lettuce",
  "lettuce leaves": "lettuce",
  "sorrel leaves": "sorrel_leaves",
  "gongura": "sorrel_leaves",
  "pulicha keerai": "sorrel_leaves",
  "ambadi": "sorrel_leaves",
  "khatta palak": "sorrel_leaves",
  "pundi soppu": "sorrel_leaves",
  "curry leaves": "curry_leaves",
  "kadi patta": "curry_leaves",
  "karipatta": "curry_leaves",
  "kariveppilai": "curry_leaves",
  "karivepaku": "curry_leaves",
  "karibevu": "curry_leaves",
  "curry leaf": "curry_leaves",
  "meetha neem": "curry_leaves",
  "coriander leaves": "coriander_leaves",
  "cilantro": "coriander_leaves",
  "dhania": "coriander_leaves",
  "dhaniya": "coriander_leaves",
  "hara dhania": "coriander_leaves",
  "kothmir": "coriander_leaves",
  "kothambari soppu": "coriander_leaves",
  "kotmir": "coriander_leaves",
  "kothamalli": "coriander_leaves",
  "kothimeera": "coriander_leaves",
  "coriander": "coriander_leaves",
  "fresh coriander": "coriander_leaves",
  "mint leaves": "mint_leaves",
  "pudina": "mint_leaves",
  "podina": "mint_leaves",
  "putina": "mint_leaves",
  "mint": "mint_leaves",
  "fresh mint": "mint_leaves",
  "pudhina": "mint_leaves",
  "basil": "basil",
  "sweet basil": "basil",
  "italian basil": "basil",
  "parsley": "parsley",
  "ajmoda leaves": "parsley",
  "flat leaf parsley": "parsley",
  "italian parsley": "parsley",
  "oregano": "oregano",
  "origano": "oregano",
  "wild marjoram": "oregano",
  "pizza herb": "oregano",
  "thyme": "thyme",
  "thaim": "thyme",
  "rosemary": "rosemary",
  "rosmary": "rosemary",
  "bay leaf": "bay_leaf",
  "tej patta": "bay_leaf",
  "tejpatta": "bay_leaf",
  "biryani leaf": "bay_leaf",
  "bay leaves": "bay_leaf",
  "brinji leaf": "bay_leaf",
  "patta": "bay_leaf",
  "tamalapatri": "bay_leaf",
  "turmeric powder": "turmeric_powder",
  "haldi": "turmeric_powder",
  "haldi powder": "turmeric_powder",
  "manjal": "turmeric_powder",
  "arishina": "turmeric_powder",
  "pasupu": "turmeric_powder",
  "turmeric": "turmeric_powder",
  "haldi pwd": "turmeric_powder",
  "red chilli powder": "red_chilli_powder",
  "lal mirch": "red_chilli_powder",
  "lal mirch powder": "red_chilli_powder",
  "mirchi powder": "red_chilli_powder",
  "menasina pudi": "red_chilli_powder",
  "karam podi": "red_chilli_powder",
  "chilli powder": "red_chilli_powder",
  "chili powder": "red_chilli_powder",
  "kashmiri chilli powder": "red_chilli_powder",
  "kashmiri chilli": "red_chilli_powder",
  "degi mirch": "red_chilli_powder",
  "coriander powder": "coriander_powder",
  "dhania powder": "coriander_powder",
  "dhaniya powder": "coriander_powder",
  "kothamalli podi": "coriander_powder",
  "coriander seed powder": "coriander_powder",
  "coriander seeds": "coriander_seeds",
  "dhania seeds": "coriander_seeds",
  "dhaniya seeds": "coriander_seeds",
  "sabut dhania": "coriander_seeds",
  "whole coriander": "coriander_seeds",
  "coriander seed": "coriander_seeds",
  "kothamalli seeds": "coriander_seeds",
  "dhania whole": "coriander_seeds",
  "cumin powder": "cumin_powder",
  "jeera powder": "cumin_powder",
  "zeera powder": "cumin_powder",
  "jeerige pudi": "cumin_powder",
  "jilakarra powder": "cumin_powder",
  "ground cumin": "cumin_powder",
  "cumin seeds": "cumin_seeds",
  "jeera": "cumin_seeds",
  "zeera": "cumin_seeds",
  "jeerige": "cumin_seeds",
  "jeeragam": "cumin_seeds",
  "jilakarra": "cumin_seeds",
  "cumin": "cumin_seeds",
  "whole cumin": "cumin_seeds",
  "jeera whole": "cumin_seeds",
  "catch jeera whole": "cumin_seeds",
  "mustard seeds": "mustard_seeds",
  "rai": "mustard_seeds",
  "kadugu": "mustard_seeds",
  "sasive": "mustard_seeds",
  "avalu": "mustard_seeds",
  "mustard": "mustard_seeds",
  "black mustard": "mustard_seeds",
  "small mustard": "mustard_seeds",
  "fenugreek seeds": "fenugreek_seeds",
  "methi dana": "fenugreek_seeds",
  "methi seeds": "fenugreek_seeds",
  "vendhayam": "fenugreek_seeds",
  "menthya": "fenugreek_seeds",
  "menthulu": "fenugreek_seeds",
  "kasuri methi seeds": "fenugreek_seeds",
  "fennel seeds": "fennel_seeds",
  "saunf": "fennel_seeds",
  "sonf": "fennel_seeds",
  "perinjeeragam": "fennel_seeds",
  "sompu": "fennel_seeds",
  "badi saunf": "fennel_seeds",
  "sweet cumin": "fennel_seeds",
  "anise seed": "fennel_seeds",
  "carom seeds": "carom_seeds",
  "ajwain": "carom_seeds",
  "ajowan": "carom_seeds",
  "omam": "carom_seeds",
  "vamu": "carom_seeds",
  "oma": "carom_seeds",
  "bishop's weed": "carom_seeds",
  "carrom seeds": "carom_seeds",
  "nigella seeds": "nigella_seeds",
  "kalonji": "nigella_seeds",
  "black cumin": "nigella_seeds",
  "onion seeds": "nigella_seeds",
  "kala jeera": "nigella_seeds",
  "mangrail": "nigella_seeds",
  "asafoetida": "asafoetida",
  "hing": "asafoetida",
  "heeng": "asafoetida",
  "perungayam": "asafoetida",
  "ingu": "asafoetida",
  "inguva": "asafoetida",
  "asafetida": "asafoetida",
  "black pepper": "black_pepper",
  "kali mirch": "black_pepper",
  "kalimirch": "black_pepper",
  "milagu": "black_pepper",
  "menasu": "black_pepper",
  "miriyalu": "black_pepper",
  "peppercorn": "black_pepper",
  "pepper": "black_pepper",
  "whole pepper": "black_pepper",
  "black peppercorns": "black_pepper",
  "white pepper": "white_pepper",
  "safed mirch": "white_pepper",
  "white pepper powder": "white_pepper",
  "green cardamom": "cardamom_green",
  "elaichi": "cardamom_green",
  "elachi": "cardamom_green",
  "ilaichi": "cardamom_green",
  "yelakki": "cardamom_green",
  "elakkai": "cardamom_green",
  "yalakulu": "cardamom_green",
  "cardamom": "cardamom_green",
  "choti elaichi": "cardamom_green",
  "black cardamom": "cardamom_black",
  "badi elaichi": "cardamom_black",
  "kali elaichi": "cardamom_black",
  "moti elaichi": "cardamom_black",
  "brown cardamom": "cardamom_black",
  "cloves": "cloves",
  "laung": "cloves",
  "lavang": "cloves",
  "krambu": "cloves",
  "lavanga": "cloves",
  "clove": "cloves",
  "kirambu": "cloves",
  "cinnamon": "cinnamon",
  "dalchini": "cinnamon",
  "dal chini": "cinnamon",
  "pattai": "cinnamon",
  "chakke": "cinnamon",
  "lavangapattai": "cinnamon",
  "cinnamon stick": "cinnamon",
  "cinnamon bark": "cinnamon",
  "nutmeg": "nutmeg",
  "jaiphal": "nutmeg",
  "jayikai": "nutmeg",
  "jathikai": "nutmeg",
  "jajikaya": "nutmeg",
  "mace": "mace",
  "javitri": "mace",
  "japatri": "mace",
  "jathipatri": "mace",
  "nutmeg flower": "mace",
  "star anise": "star_anise",
  "chakra phool": "star_anise",
  "anasphal": "star_anise",
  "biryani flower": "star_anise",
  "annachi poo": "star_anise",
  "dry red chilli": "dry_red_chilli",
  "sukhi lal mirch": "dry_red_chilli",
  "vara milagai": "dry_red_chilli",
  "kempu menasina kai": "dry_red_chilli",
  "endu mirapakaya": "dry_red_chilli",
  "byadgi chilli": "dry_red_chilli",
  "guntur chilli": "dry_red_chilli",
  "dried red chilli": "dry_red_chilli",
  "whole red chilli": "dry_red_chilli",
  "dry ginger": "dry_ginger",
  "sonth": "dry_ginger",
  "saunth": "dry_ginger",
  "sukku": "dry_ginger",
  "shunti pudi": "dry_ginger",
  "dried ginger": "dry_ginger",
  "ginger powder": "dry_ginger",
  "tamarind": "tamarind",
  "imli": "tamarind",
  "puli": "tamarind",
  "hunase": "tamarind",
  "chinta pandu": "tamarind",
  "tamarind pulp": "tamarind",
  "dry mango powder": "dry_mango_powder",
  "amchur": "dry_mango_powder",
  "amchoor": "dry_mango_powder",
  "aamchur": "dry_mango_powder",
  "mango powder": "dry_mango_powder",
  "kokum": "kokum",
  "amsul": "kokum",
  "bhinda": "kokum",
  "garcinia": "kokum",
  "punarpuli": "kokum",
  "poppy seeds": "poppy_seeds",
  "khus khus": "poppy_seeds",
  "khuskhus": "poppy_seeds",
  "gasagase": "poppy_seeds",
  "gasalu": "poppy_seeds",
  "kasakasa": "poppy_seeds",
  "stone flower": "stone_flower",
  "dagad phool": "stone_flower",
  "kalpasi": "stone_flower",
  "black stone flower": "stone_flower",
  "patthar phool": "stone_flower",
  "saffron": "saffron",
  "kesar": "saffron",
  "zafran": "saffron",
  "kumkuma poovu": "saffron",
  "saffron strands": "saffron",
  "garam masala": "garam_masala",
  "garam masala powder": "garam_masala",
  "gm masala": "garam_masala",
  "sambar powder": "sambar_powder",
  "sambhar powder": "sambar_powder",
  "sambar podi": "sambar_powder",
  "saaru pudi": "sambar_powder",
  "rasam powder": "rasam_powder",
  "rasam podi": "rasam_powder",
  "charu podi": "rasam_powder",
  "chaat masala": "chaat_masala",
  "chat masala": "chaat_masala",
  "chaat masaala": "chaat_masala",
  "pav bhaji masala": "pav_bhaji_masala",
  "pao bhaji masala": "pav_bhaji_masala",
  "biryani masala": "biryani_masala",
  "biriyani masala": "biryani_masala",
  "biryani powder": "biryani_masala",
  "kitchen king masala": "kitchen_king_masala",
  "kitchen king": "kitchen_king_masala",
  "tandoori masala": "tandoori_masala",
  "tandoori powder": "tandoori_masala",
  "tikka masala powder": "tandoori_masala",
  "kasuri methi": "kasuri_methi",
  "dried fenugreek leaves": "kasuri_methi",
  "kasoori methi": "kasuri_methi",
  "dry methi": "kasuri_methi",
  "meat masala": "everest_garam",
  "chicken masala": "everest_garam",
  "mutton masala": "everest_garam",
  "fish masala": "everest_garam",
  "non veg masala": "everest_garam",
  "rice": "rice",
  "chawal": "rice",
  "chaval": "rice",
  "akki": "rice",
  "arisi": "rice",
  "biyyam": "rice",
  "raw rice": "rice",
  "white rice": "rice",
  "sona masoori": "rice",
  "ponni rice": "rice",
  "boiled rice": "rice",
  "idli rice": "rice",
  "brown rice": "brown_rice",
  "brown chawal": "brown_rice",
  "unpolished rice": "brown_rice",
  "hand pounded rice": "brown_rice",
  "basmati rice": "basmati_rice",
  "basmati": "basmati_rice",
  "long grain rice": "basmati_rice",
  "biryani rice": "basmati_rice",
  "flattened rice": "poha",
  "poha": "poha",
  "pova": "poha",
  "aval": "poha",
  "avalakki": "poha",
  "atukulu": "poha",
  "beaten rice": "poha",
  "chiwda raw": "poha",
  "puffed rice": "puffed_rice",
  "murmura": "puffed_rice",
  "mamra": "puffed_rice",
  "pori": "puffed_rice",
  "mandakki": "puffed_rice",
  "borugulu": "puffed_rice",
  "kurmura": "puffed_rice",
  "churmura": "puffed_rice",
  "wheat": "wheat",
  "gehu": "wheat",
  "gehun": "wheat",
  "godhi": "wheat",
  "godhuma": "wheat",
  "godumai": "wheat",
  "whole wheat": "wheat",
  "broken wheat": "broken_wheat",
  "dalia": "broken_wheat",
  "daliya": "broken_wheat",
  "godhi rava": "broken_wheat",
  "godhuma rava": "broken_wheat",
  "samba rava": "broken_wheat",
  "lapsi": "broken_wheat",
  "cracked wheat": "broken_wheat",
  "bulgur": "broken_wheat",
  "semolina": "semolina",
  "rava": "semolina",
  "sooji": "semolina",
  "suji": "semolina",
  "ravva": "semolina",
  "chiroti rava": "semolina",
  "bombay rava": "semolina",
  "upma rava": "semolina",
  "vermicelli": "vermicelli",
  "seviyan": "vermicelli",
  "semiya": "vermicelli",
  "shavige": "vermicelli",
  "vermicili": "vermicelli",
  "sev pasta": "vermicelli",
  "oats": "oats",
  "jai": "oats",
  "rolled oats": "oats",
  "instant oats": "oats",
  "oatmeal": "oats",
  "barley": "barley",
  "jau": "barley",
  "jav": "barley",
  "barli": "barley",
  "quinoa": "quinoa",
  "keenwa": "quinoa",
  "kinwa": "quinoa",
  "finger millet": "ragi",
  "ragi": "ragi",
  "nachni": "ragi",
  "kelvaragu": "ragi",
  "mandua": "ragi",
  "ragulu": "ragi",
  "pearl millet": "bajra",
  "bajra": "bajra",
  "sajje": "bajra",
  "kambu": "bajra",
  "sajjalu": "bajra",
  "sorghum": "jowar",
  "jowar": "jowar",
  "jola": "jowar",
  "cholam": "jowar",
  "jonna": "jowar",
  "great millet": "jowar",
  "foxtail millet": "foxtail_millet",
  "kangni": "foxtail_millet",
  "navane": "foxtail_millet",
  "thinai": "foxtail_millet",
  "korralu": "foxtail_millet",
  "little millet": "little_millet",
  "kutki": "little_millet",
  "saame": "little_millet",
  "samai": "little_millet",
  "samalu": "little_millet",
  "kodo millet": "kodo_millet",
  "kodra": "kodo_millet",
  "harka": "kodo_millet",
  "varagu": "kodo_millet",
  "arikelu": "kodo_millet",
  "sago": "sabudana",
  "sabudana": "sabudana",
  "sabu dana": "sabudana",
  "javvarisi": "sabudana",
  "saggubiyyam": "sabudana",
  "tapioca pearls": "sabudana",
  "sago pearls": "sabudana",
  "wheat flour": "wheat_flour",
  "atta": "wheat_flour",
  "aata": "wheat_flour",
  "gehu atta": "wheat_flour",
  "godhi hittu": "wheat_flour",
  "godhuma pindi": "wheat_flour",
  "chapati flour": "wheat_flour",
  "whole wheat flour": "wheat_flour",
  "wheat flour atta": "wheat_flour",
  "aashirvaad superior mp atta": "wheat_flour",
  "aashirvaad atta": "wheat_flour",
  "all purpose flour": "all_purpose_flour",
  "maida": "all_purpose_flour",
  "refined flour": "all_purpose_flour",
  "plain flour": "all_purpose_flour",
  "white flour": "all_purpose_flour",
  "maida flour": "all_purpose_flour",
  "gram flour": "gram_flour",
  "besan": "gram_flour",
  "chickpea flour": "gram_flour",
  "kadalai maavu": "gram_flour",
  "kadle hittu": "gram_flour",
  "senaga pindi": "gram_flour",
  "garbanzo flour": "gram_flour",
  "rice flour": "rice_flour",
  "chawal atta": "rice_flour",
  "akki hittu": "rice_flour",
  "arisi maavu": "rice_flour",
  "biyyam pindi": "rice_flour",
  "rice powder": "rice_flour",
  "corn flour": "corn_flour",
  "cornflour": "corn_flour",
  "corn meal": "corn_meal",
  "makki atta": "corn_meal",
  "makka atta": "corn_meal",
  "maize flour": "corn_meal",
  "cornmeal": "corn_meal",
  "ragi flour": "ragi_flour",
  "ragi hittu": "ragi_flour",
  "ragi atta": "ragi_flour",
  "nachni flour": "ragi_flour",
  "finger millet flour": "ragi_flour",
  "jowar flour": "jowar_flour",
  "jola hittu": "jowar_flour",
  "jowar atta": "jowar_flour",
  "sorghum flour": "jowar_flour",
  "bajra flour": "bajra_flour",
  "sajje hittu": "bajra_flour",
  "bajra atta": "bajra_flour",
  "pearl millet flour": "bajra_flour",
  "idli rava": "semolina_flour",
  "idli rave": "semolina_flour",
  "rice rava": "semolina_flour",
  "coarse rice flour": "semolina_flour",
  "toor dal": "toor_dal",
  "arhar dal": "toor_dal",
  "tur dal": "toor_dal",
  "toovar dal": "toor_dal",
  "thuvaram paruppu": "toor_dal",
  "togari bele": "toor_dal",
  "kandi pappu": "toor_dal",
  "pigeon pea": "toor_dal",
  "red gram": "toor_dal",
  "split pigeon pea": "toor_dal",
  "moong dal": "moong_dal",
  "mung dal": "moong_dal",
  "green gram split": "moong_dal",
  "pesara pappu": "moong_dal",
  "hesaru bele": "moong_dal",
  "pasi paruppu": "moong_dal",
  "yellow moong dal": "moong_dal",
  "split green gram": "moong_dal",
  "whole green gram": "whole_moong",
  "sabut moong": "whole_moong",
  "hara moong": "whole_moong",
  "whole moong": "whole_moong",
  "green gram whole": "whole_moong",
  "pachai payaru": "whole_moong",
  "whole green moong": "whole_moong",
  "green moong whole": "whole_moong",
  "moong sprouts": "moong_sprouts",
  "green moong sprouts": "moong_sprouts",
  "sprouted moong": "moong_sprouts",
  "ankurit moong": "moong_sprouts",
  "moong dal sprouts": "moong_sprouts",
  "bean sprouts moong": "moong_sprouts",
  "sprouts moong": "moong_sprouts",
  "masoor dal": "masoor_dal",
  "red lentil": "masoor_dal",
  "masur dal": "masoor_dal",
  "mysore paruppu": "masoor_dal",
  "split red lentil": "masoor_dal",
  "pink lentil": "masoor_dal",
  "whole brown lentil": "whole_masoor",
  "sabut masoor": "whole_masoor",
  "brown lentil": "whole_masoor",
  "whole masoor": "whole_masoor",
  "kala masoor": "whole_masoor",
  "urad dal": "urad_dal",
  "black gram split": "urad_dal",
  "ulutham paruppu": "urad_dal",
  "uddina bele": "urad_dal",
  "minapa pappu": "urad_dal",
  "split black gram": "urad_dal",
  "white urad dal": "urad_dal",
  "urad dal white": "urad_dal",
  "whole black gram": "whole_urad",
  "sabut urad": "whole_urad",
  "black gram whole": "whole_urad",
  "kali dal": "whole_urad",
  "ma ki dal": "whole_urad",
  "chana dal": "chana_dal",
  "bengal gram split": "chana_dal",
  "kadalai paruppu": "chana_dal",
  "kadle bele": "chana_dal",
  "senaga pappu": "chana_dal",
  "split chickpea": "chana_dal",
  "gram dal": "chana_dal",
  "chickpeas": "kabuli_chana",
  "kabuli chana": "kabuli_chana",
  "chhole": "kabuli_chana",
  "chole": "kabuli_chana",
  "garbanzo beans": "kabuli_chana",
  "white chana": "kabuli_chana",
  "safed chana": "kabuli_chana",
  "black chickpeas": "kala_chana",
  "kala chana": "kala_chana",
  "brown chana": "kala_chana",
  "bengal gram whole": "kala_chana",
  "kadale kalu": "kala_chana",
  "konda kadalai": "kala_chana",
  "black chana": "kala_chana",
  "kidney beans": "rajma",
  "rajma": "rajma",
  "red kidney beans": "rajma",
  "rajmah": "rajma",
  "kidney bean": "rajma",
  "black eyed peas": "lobia",
  "lobia": "lobia",
  "chawli": "lobia",
  "karamani": "lobia",
  "alasandalu": "lobia",
  "cowpea": "lobia",
  "black eyed beans": "lobia",
  "thatta payir": "lobia",
  "moth beans": "moth_beans",
  "matki": "moth_beans",
  "moth": "moth_beans",
  "matki beans": "moth_beans",
  "turkish gram": "moth_beans",
  "horse gram": "horse_gram",
  "kulthi": "horse_gram",
  "hurali": "horse_gram",
  "kollu": "horse_gram",
  "ulavalu": "horse_gram",
  "muthira": "horse_gram",
  "green moong dal split": "green_moong_dal",
  "chilka moong": "green_moong_dal",
  "split green gram with skin": "green_moong_dal",
  "green moong split": "green_moong_dal",
  "soya chunks": "soya_chunks",
  "soya nuggets": "soya_chunks",
  "meal maker": "soya_chunks",
  "nutrela": "soya_chunks",
  "textured vegetable protein": "soya_chunks",
  "soya badi": "soya_chunks",
  "soy chunks": "soya_chunks",
  "milk": "milk",
  "doodh": "milk",
  "dudh": "milk",
  "haalu": "milk",
  "paalu": "milk",
  "paal": "milk",
  "cow milk": "milk",
  "buffalo milk": "milk",
  "fresh milk": "milk",
  "curd": "curd",
  "dahi": "curd",
  "yogurt": "curd",
  "yoghurt": "curd",
  "mosaru": "curd",
  "perugu": "curd",
  "thayir": "curd",
  "plain yogurt": "curd",
  "set curd": "curd",
  "buttermilk": "buttermilk",
  "chaas": "buttermilk",
  "chhachh": "buttermilk",
  "majjige": "buttermilk",
  "majjiga": "buttermilk",
  "moru": "buttermilk",
  "neer mor": "buttermilk",
  "lassi salted": "buttermilk",
  "paneer": "paneer",
  "cottage cheese": "paneer",
  "panir": "paneer",
  "indian cheese": "paneer",
  "chenna": "paneer",
  "cheese": "cheese",
  "chiz": "cheese",
  "amul cheese": "cheese",
  "butter": "butter",
  "makkhan": "butter",
  "makhan": "butter",
  "benne": "butter",
  "venna": "butter",
  "vennai": "butter",
  "salted butter": "butter",
  "unsalted butter": "butter",
  "amul butter": "butter",
  "white butter": "butter",
  "ghee": "ghee",
  "clarified butter": "ghee",
  "tup": "ghee",
  "neyyi": "ghee",
  "tuppa": "ghee",
  "nei": "ghee",
  "desi ghee": "ghee",
  "cow ghee": "ghee",
  "cream": "cream",
  "malai": "cream",
  "fresh cream": "cream",
  "amul cream": "cream",
  "condensed milk": "condensed_milk",
  "milkmaid": "condensed_milk",
  "sweetened condensed milk": "condensed_milk",
  "condensed": "condensed_milk",
  "khoya": "khoya",
  "mawa": "khoya",
  "khoa": "khoya",
  "dried milk solids": "khoya",
  "mava": "khoya",
  "milk powder": "milk_powder",
  "dried milk": "milk_powder",
  "powdered milk": "milk_powder",
  "skimmed milk powder": "milk_powder",
  "smp": "milk_powder",
  "egg": "egg",
  "anda": "egg",
  "ande": "egg",
  "mutta": "egg",
  "gudlu": "egg",
  "kodi guddu": "egg",
  "eggs": "egg",
  "hen egg": "egg",
  "whole egg": "egg",
  "chicken": "chicken",
  "murgi": "chicken",
  "murga": "chicken",
  "kodi": "chicken",
  "chikan": "chicken",
  "chiken": "chicken",
  "boneless chicken": "chicken",
  "chicken breast": "chicken",
  "chicken curry cut": "chicken",
  "broiler chicken": "chicken",
  "chicken leg": "chicken_leg",
  "chicken drumstick": "chicken_leg",
  "leg piece": "chicken_leg",
  "chicken wings": "chicken_wings",
  "wings": "chicken_wings",
  "murgi wings": "chicken_wings",
  "chicken mince": "chicken_keema",
  "chicken keema": "chicken_keema",
  "minced chicken": "chicken_keema",
  "chicken qeema": "chicken_keema",
  "ground chicken": "chicken_keema",
  "duck": "duck",
  "batak": "duck",
  "duck meat": "duck",
  "turkey": "turkey",
  "turkey meat": "turkey",
  "mutton": "mutton",
  "goat meat": "mutton",
  "bakra": "mutton",
  "muton": "mutton",
  "mutton curry cut": "mutton",
  "goat": "mutton",
  "chevon": "mutton",
  "mutton mince": "mutton_keema",
  "keema": "mutton_keema",
  "qeema": "mutton_keema",
  "minced mutton": "mutton_keema",
  "ground mutton": "mutton_keema",
  "kheema": "mutton_keema",
  "beef": "beef",
  "beef meat": "beef",
  "buff": "beef",
  "buffalo meat": "beef",
  "pork": "pork",
  "suar": "pork",
  "pork meat": "pork",
  "liver": "liver",
  "kaleji": "liver",
  "chicken liver": "liver",
  "mutton liver": "liver",
  "fish": "fish",
  "machli": "fish",
  "machhi": "fish",
  "meen": "fish",
  "chepa": "fish",
  "fish curry cut": "fish",
  "fresh fish": "fish",
  "rohu": "rohu",
  "rohu fish": "rohu",
  "rui": "rohu",
  "rui machh": "rohu",
  "katla": "katla",
  "catla": "katla",
  "katla fish": "katla",
  "pomfret": "pomfret",
  "paplet": "pomfret",
  "vavval": "pomfret",
  "white pomfret": "pomfret",
  "black pomfret": "pomfret",
  "mackerel": "mackerel",
  "bangda": "mackerel",
  "ayala": "mackerel",
  "bangude": "mackerel",
  "indian mackerel": "mackerel",
  "sardine": "sardine",
  "mathi": "sardine",
  "tarli": "sardine",
  "pedvey": "sardine",
  "sardines": "sardine",
  "tuna": "tuna",
  "choora": "tuna",
  "tuna fish": "tuna",
  "salmon": "salmon",
  "salmon fish": "salmon",
  "prawns": "prawns",
  "jhinga": "prawns",
  "shrimp": "prawns",
  "eral": "prawns",
  "royyalu": "prawns",
  "sigadi": "prawns",
  "prawn": "prawns",
  "chemmeen": "prawns",
  "crab": "crab",
  "kekda": "crab",
  "nandu": "crab",
  "crab meat": "crab",
  "squid": "squid",
  "calamari": "squid",
  "kanava": "squid",
  "koonthal": "squid",
  "peanut": "peanut",
  "groundnut": "peanut",
  "moongphali": "peanut",
  "mungfali": "peanut",
  "kadalekai": "peanut",
  "verkadalai": "peanut",
  "palli": "peanut",
  "shengdana": "peanut",
  "groundnuts": "peanut",
  "peanuts": "peanut",
  "cashew": "cashew",
  "kaju": "cashew",
  "cashew nut": "cashew",
  "geru": "cashew",
  "mundiri": "cashew",
  "jeedipappu": "cashew",
  "cashews": "cashew",
  "kaju nuts": "cashew",
  "almond": "almond",
  "badam": "almond",
  "almonds": "almond",
  "badaam": "almond",
  "badami": "almond",
  "pistachio": "pistachio",
  "pista": "pistachio",
  "pistachios": "pistachio",
  "pistha": "pistachio",
  "walnut": "walnut",
  "akhrot": "walnut",
  "walnuts": "walnut",
  "akhroat": "walnut",
  "hazelnut": "hazelnut",
  "hazelnuts": "hazelnut",
  "pine nuts": "pine_nuts",
  "chilgoza": "pine_nuts",
  "neja": "pine_nuts",
  "coconut": "coconut",
  "nariyal": "coconut",
  "khopra": "coconut",
  "thengai": "coconut",
  "kobbari": "coconut",
  "tengina kai": "coconut",
  "fresh coconut": "coconut",
  "grated coconut": "coconut",
  "dry coconut": "dry_coconut",
  "copra": "dry_coconut",
  "khopra dry": "dry_coconut",
  "kobbari dry": "dry_coconut",
  "desiccated coconut": "dry_coconut",
  "coconut powder": "dry_coconut",
  "sesame seeds": "sesame_seeds",
  "til": "sesame_seeds",
  "ellu": "sesame_seeds",
  "nuvvulu": "sesame_seeds",
  "yellu": "sesame_seeds",
  "gingelly seeds": "sesame_seeds",
  "white sesame": "sesame_seeds",
  "black sesame": "sesame_seeds",
  "tila": "sesame_seeds",
  "flax seeds": "flax_seeds",
  "alsi": "flax_seeds",
  "jawas": "flax_seeds",
  "linseed": "flax_seeds",
  "ali vidai": "flax_seeds",
  "agase": "flax_seeds",
  "chia seeds": "chia_seeds",
  "chia": "chia_seeds",
  "sabja substitute": "chia_seeds",
  "sunflower seeds": "sunflower_seeds",
  "surajmukhi seeds": "sunflower_seeds",
  "pumpkin seeds": "pumpkin_seeds",
  "pepita": "pumpkin_seeds",
  "kaddu seeds": "pumpkin_seeds",
  "watermelon seeds": "watermelon_seeds",
  "magaz": "watermelon_seeds",
  "char magaz": "watermelon_seeds",
  "tarbooj seeds": "watermelon_seeds",
  "basil seeds": "basil_seeds",
  "sabja": "basil_seeds",
  "tukmaria": "basil_seeds",
  "falooda seeds": "basil_seeds",
  "sabja seeds": "basil_seeds",
  "raisins": "raisin",
  "kishmish": "raisin",
  "kismis": "raisin",
  "dry grapes": "raisin",
  "manuka": "raisin",
  "drakshi": "raisin",
  "sultana": "raisin",
  "raisin": "raisin",
  "dates": "date",
  "khajur": "date",
  "kharik": "date",
  "kharjura": "date",
  "dry dates": "date",
  "khajoor": "date",
  "date": "date",
  "dried fig": "fig",
  "anjeer": "fig",
  "anjir": "fig",
  "fig": "fig",
  "dried figs": "fig",
  "dried apricot": "apricot",
  "khubani": "apricot",
  "jardalu": "apricot",
  "apricot": "apricot",
  "prunes": "prune",
  "dried plum": "prune",
  "sukha aloo bukhara": "prune",
  "banana": "banana",
  "kela": "banana",
  "bale hannu": "banana",
  "vazhai pazham": "banana",
  "arati pandu": "banana",
  "banana ripe": "banana",
  "bananas": "banana",
  "apple": "apple",
  "seb": "apple",
  "sebu": "apple",
  "apple fruit": "apple",
  "apples": "apple",
  "mango": "mango",
  "aam": "mango",
  "mavinhannu": "mango",
  "mamidi pandu": "mango",
  "mangai": "mango",
  "mango ripe": "mango",
  "alphonso": "mango",
  "mangoes": "mango",
  "orange": "orange",
  "santra": "orange",
  "narangi": "orange",
  "kittale": "orange",
  "kamala": "orange",
  "oranges": "orange",
  "sweet lime": "sweet_lime",
  "mosambi": "sweet_lime",
  "musambi": "sweet_lime",
  "sathukudi": "sweet_lime",
  "battayi": "sweet_lime",
  "lemon": "lemon",
  "nimbu": "lemon",
  "elumichai": "lemon",
  "nimbe hannu": "lemon",
  "nimmakaya": "lemon",
  "lime": "lemon",
  "lemons": "lemon",
  "nimboo": "lemon",
  "grapes": "grapes",
  "angoor": "grapes",
  "dhraksha": "grapes",
  "grape": "grapes",
  "green grapes": "grapes",
  "black grapes": "grapes",
  "pomegranate": "pomegranate",
  "anar": "pomegranate",
  "dalimbe": "pomegranate",
  "danimma": "pomegranate",
  "mathulai": "pomegranate",
  "pomegranate seeds": "pomegranate",
  "anardana fresh": "pomegranate",
  "watermelon": "watermelon",
  "tarbooj": "watermelon",
  "kallangadi": "watermelon",
  "puchakaya": "watermelon",
  "kalingad": "watermelon",
  "muskmelon": "muskmelon",
  "kharbooja": "muskmelon",
  "kharbuja": "muskmelon",
  "cantaloupe": "muskmelon",
  "musk melon": "muskmelon",
  "papaya": "papaya",
  "papita": "papaya",
  "pappali": "papaya",
  "boppayi": "papaya",
  "papaw": "papaya",
  "ripe papaya": "papaya",
  "guava": "guava",
  "amrood": "guava",
  "peru": "guava",
  "koyya": "guava",
  "sebe hannu": "guava",
  "jamapandu": "guava",
  "pineapple": "pineapple",
  "ananas": "pineapple",
  "annasi": "pineapple",
  "pine apple": "pineapple",
  "pear": "pear",
  "nashpati": "pear",
  "babbu": "pear",
  "pears": "pear",
  "custard apple": "custard_apple",
  "sitaphal": "custard_apple",
  "sharifa": "custard_apple",
  "sita pazham": "custard_apple",
  "sitaphalam": "custard_apple",
  "sugar apple": "custard_apple",
  "sapota": "sapota",
  "chikoo": "sapota",
  "chiku": "sapota",
  "sapodilla": "sapota",
  "sapot": "sapota",
  "sima chinta": "sapota",
  "jackfruit": "jackfruit",
  "kathal": "jackfruit",
  "halasina hannu": "jackfruit",
  "pala pazham": "jackfruit",
  "panasa": "jackfruit",
  "kathal ripe": "jackfruit",
  "strawberry": "strawberry",
  "strawberries": "strawberry",
  "kiwi": "kiwi",
  "kiwi fruit": "kiwi",
  "avocado": "avocado",
  "butter fruit": "avocado",
  "makhanphal": "avocado",
  "avacado": "avocado",
  "litchi": "litchi",
  "lychee": "litchi",
  "leechi": "litchi",
  "lichi": "litchi",
  "sugar": "sugar",
  "cheeni": "sugar",
  "chini": "sugar",
  "sakkare": "sugar",
  "panchadara": "sugar",
  "sakkarai": "sugar",
  "white sugar": "sugar",
  "shakkar": "sugar",
  "granulated sugar": "sugar",
  "brown sugar": "brown_sugar",
  "bura sugar": "brown_sugar",
  "demerara": "brown_sugar",
  "raw sugar": "brown_sugar",
  "jaggery": "jaggery",
  "gud": "jaggery",
  "gur": "jaggery",
  "bella": "jaggery",
  "vellam": "jaggery",
  "bellam": "jaggery",
  "jaggary": "jaggery",
  "palm jaggery": "jaggery",
  "nattu sakkarai": "jaggery",
  "honey": "honey",
  "shahad": "honey",
  "shahd": "honey",
  "jenu": "honey",
  "ten": "honey",
  "tene": "honey",
  "madhu": "honey",
  "powdered sugar": "powdered_sugar",
  "icing sugar": "powdered_sugar",
  "confectioners sugar": "powdered_sugar",
  "boora": "powdered_sugar",
  "tagar": "powdered_sugar",
  "palm sugar": "palm_sugar",
  "panangkarkandu": "palm_sugar",
  "karupatti": "palm_sugar",
  "palm candy": "palm_sugar",
  "rock sugar": "rock_sugar",
  "mishri": "rock_sugar",
  "kalkandu": "rock_sugar",
  "kallu sakkare": "rock_sugar",
  "patika bellam": "rock_sugar",
  "rock candy": "rock_sugar",
  "diamond sugar": "rock_sugar",
  "maple syrup": "maple_syrup",
  "maple": "maple_syrup",
  "salt": "salt",
  "namak": "salt",
  "uppu": "salt",
  "uppinakai salt": "salt",
  "table salt": "salt",
  "iodized salt": "salt",
  "sea salt": "salt",
  "namak salt": "salt",
  "rock salt": "rock_salt",
  "sendha namak": "rock_salt",
  "kallu uppu": "rock_salt",
  "saindhava lavana": "rock_salt",
  "himalayan salt": "rock_salt",
  "vrat salt": "rock_salt",
  "black salt": "black_salt",
  "kala namak": "black_salt",
  "sanchal": "black_salt",
  "himalayan black salt": "black_salt",
  "vinegar": "vinegar",
  "sirka": "vinegar",
  "white vinegar": "vinegar",
  "apple cider vinegar": "vinegar",
  "synthetic vinegar": "vinegar",
  "soy sauce": "soy_sauce",
  "soya sauce": "soy_sauce",
  "soyasauce": "soy_sauce",
  "light soy sauce": "soy_sauce",
  "dark soy sauce": "soy_sauce",
  "tomato ketchup": "tomato_ketchup",
  "ketchup": "tomato_ketchup",
  "tomato sauce": "tomato_ketchup",
  "tomato ketchup sauce": "tomato_ketchup",
  "catsup": "tomato_ketchup",
  "chilli sauce": "chilli_sauce",
  "red chilli sauce": "chilli_sauce",
  "green chilli sauce": "chilli_sauce",
  "chili sauce": "chilli_sauce",
  "schezwan sauce": "chilli_sauce",
  "rice vinegar": "vinegar_rice",
  "rice wine vinegar": "vinegar_rice",
  "mayonnaise": "mayonnaise",
  "mayo": "mayonnaise",
  "eggless mayo": "mayonnaise",
  "veg mayonnaise": "mayonnaise",
  "mustard sauce": "mustard_sauce",
  "mustard paste": "mustard_sauce",
  "yellow mustard": "mustard_sauce",
  "fish sauce": "fish_sauce",
  "nam pla": "fish_sauce",
  "nuoc mam": "fish_sauce",
  "oyster sauce": "oyster_sauce",
  "balsamic vinegar": "vinegar_balsamic",
  "balsamic": "vinegar_balsamic",
  "pickle": "pickle",
  "achar": "pickle",
  "achaar": "pickle",
  "uppinakai": "pickle",
  "oorugai": "pickle",
  "mango pickle": "pickle",
  "lime pickle": "pickle",
  "mixed pickle": "pickle",
  "papad": "papad",
  "papadum": "papad",
  "appalam": "papad",
  "happala": "papad",
  "appadam": "papad",
  "poppadom": "papad",
  "lijjat papad": "papad",
  "tamarind paste": "tamarind_paste",
  "imli paste": "tamarind_paste",
  "tamarind concentrate": "tamarind_paste",
  "puli paste": "tamarind_paste",
  "ginger garlic paste": "ginger_garlic_paste",
  "adrak lehsun paste": "ginger_garlic_paste",
  "gg paste": "ginger_garlic_paste",
  "ginger-garlic paste": "ginger_garlic_paste",
  "tomato puree": "tomato_puree",
  "tomato paste": "tomato_puree",
  "tamatar puree": "tomato_puree",
  "tomato concentrate": "tomato_puree",
  "passata": "tomato_puree",
  "coconut milk": "coconut_milk",
  "nariyal doodh": "coconut_milk",
  "thengai paal": "coconut_milk",
  "kobbari haalu": "coconut_milk",
  "coconut cream": "coconut_milk",
  "sunflower oil": "sunflower_oil",
  "surajmukhi tel": "sunflower_oil",
  "cooking oil": "sunflower_oil",
  "sunflower refined oil": "sunflower_oil",
  "groundnut oil": "groundnut_oil",
  "peanut oil": "groundnut_oil",
  "moongphali tel": "groundnut_oil",
  "kadalai ennai": "groundnut_oil",
  "shengdana tel": "groundnut_oil",
  "kadalekai enne": "groundnut_oil",
  "mustard oil": "mustard_oil",
  "sarson ka tel": "mustard_oil",
  "kachi ghani oil": "mustard_oil",
  "rai oil": "mustard_oil",
  "sarson oil": "mustard_oil",
  "coconut oil": "coconut_oil",
  "nariyal tel": "coconut_oil",
  "thengai ennai": "coconut_oil",
  "kobbari enne": "coconut_oil",
  "velichenna": "coconut_oil",
  "copra oil": "coconut_oil",
  "sesame oil": "sesame_oil",
  "til oil": "sesame_oil",
  "gingelly oil": "sesame_oil",
  "nallennai": "sesame_oil",
  "nuvvula nune": "sesame_oil",
  "til ka tel": "sesame_oil",
  "olive oil": "olive_oil",
  "jaitun tel": "olive_oil",
  "extra virgin olive oil": "olive_oil",
  "evoo": "olive_oil",
  "pomace olive oil": "olive_oil",
  "rice bran oil": "rice_bran_oil",
  "ricebran oil": "rice_bran_oil",
  "vanaspati": "vanaspati",
  "dalda": "vanaspati",
  "hydrogenated fat": "vanaspati",
  "vanaspathi": "vanaspati",
  "vegetable shortening": "vanaspati",
  "soybean oil": "soybean_oil",
  "soya oil": "soybean_oil",
  "soyabean oil": "soybean_oil",
  "baking powder": "baking_powder",
  "baking pwd": "baking_powder",
  "baking soda": "baking_soda",
  "meetha soda": "baking_soda",
  "sodium bicarbonate": "baking_soda",
  "cooking soda": "baking_soda",
  "soda bicarb": "baking_soda",
  "khane wala soda": "baking_soda",
  "yeast": "yeast",
  "active dry yeast": "yeast",
  "instant yeast": "yeast",
  "khameer": "yeast",
  "fresh yeast": "yeast",
  "vanilla essence": "vanilla_essence",
  "vanilla extract": "vanilla_essence",
  "vanilla flavour": "vanilla_essence",
  "vanilla": "vanilla_essence",
  "cocoa powder": "cocoa_powder",
  "coco powder": "cocoa_powder",
  "unsweetened cocoa": "cocoa_powder",
  "drinking chocolate base": "cocoa_powder",
  "chocolate": "chocolate",
  "choco": "chocolate",
  "dark chocolate": "chocolate",
  "milk chocolate": "chocolate",
  "chocolate bar": "chocolate",
  "chocolate compound": "chocolate",
  "choco chips": "chocolate",
  "chocolate chips": "chocolate",
  "gelatin": "gelatin",
  "gelatine": "gelatin",
  "china grass non veg": "gelatin",
  "agar agar": "agar_agar",
  "china grass": "agar_agar",
  "kadal pasi": "agar_agar",
  "vegetarian gelatin": "agar_agar",
  "agar": "agar_agar",
  "custard powder": "custard_powder",
  "vanilla custard powder": "custard_powder",
  "food colour": "food_color",
  "food coloring": "food_color",
  "food color": "food_color",
  "edible color": "food_color",
  "kesari color": "food_color",
  "orange food color": "food_color",
  "tea": "tea",
  "chai": "tea",
  "chai patti": "tea",
  "tea powder": "tea",
  "tea leaves": "tea",
  "black tea": "tea",
  "green tea": "tea",
  "tea dust": "tea",
  "coffee": "coffee",
  "coffee powder": "coffee",
  "instant coffee": "coffee",
  "filter coffee": "coffee",
  "kaapi": "coffee",
  "kapi": "coffee",
  "coffee beans": "coffee",
  "nescafe": "coffee",
  "drinking chocolate": "drinking_chocolate",
  "bournvita": "drinking_chocolate",
  "horlicks": "drinking_chocolate",
  "boost": "drinking_chocolate",
  "health drink": "drinking_chocolate",
  "malt drink": "drinking_chocolate",
  "soda": "soda_water",
  "soda water": "soda_water",
  "club soda": "soda_water",
  "carbonated water": "soda_water",
  "sparkling water": "soda_water",
  "fruit juice": "fruit_juice",
  "juice": "fruit_juice",
  "packaged juice": "fruit_juice",
  "real juice": "fruit_juice",
  "tropicana": "fruit_juice",
  "coconut water": "coconut_water",
  "nariyal pani": "coconut_water",
  "elaneer": "coconut_water",
  "bondam water": "coconut_water",
  "tender coconut water": "coconut_water",
  "bread": "bread",
  "double roti": "bread",
  "pav": "bread",
  "bun": "bread",
  "white bread": "bread",
  "brown bread": "bread",
  "milk bread": "bread",
  "sandwich bread": "bread",
  "pasta": "pasta",
  "macaroni": "pasta",
  "penne": "pasta",
  "spaghetti": "pasta",
  "fusilli": "pasta",
  "noodles pasta": "pasta",
  "noodles": "noodles",
  "maggi": "noodles",
  "hakka noodles": "noodles",
  "instant noodles": "noodles",
  "ramen": "noodles",
  "chowmein": "noodles",
  "atta noodles": "noodles",
  "biscuit": "biscuit",
  "biscuits": "biscuit",
  "cookies": "biscuit",
  "cracker": "biscuit",
  "marie biscuit": "biscuit",
  "parle g": "biscuit",
  "rusk": "biscuit",
  "cornflakes": "cornflakes",
  "corn flakes": "cornflakes",
  "breakfast cereal": "cornflakes",
  "muesli": "cornflakes",
  "cereal": "cornflakes",
  "tofu": "tofu",
  "soya paneer": "tofu",
  "bean curd": "tofu",
  "soy paneer": "tofu",
  "spring roll sheets": "spring_roll_sheet",
  "wrapper": "spring_roll_sheet",
  "spring roll wrapper": "spring_roll_sheet",
  "wonton sheet": "spring_roll_sheet",
  "samosa patti": "spring_roll_sheet",
  "idli batter": "idli_batter",
  "dosa batter": "idli_batter",
  "ready batter": "idli_batter",
  "fermented batter": "idli_batter",
  "curry paste": "ready_masala_paste",
  "ready curry paste": "ready_masala_paste",
  "masala paste": "ready_masala_paste",
  "water": "water",
  "pani": "water",
  "neeru": "water",
  "jal": "water",
  "neer": "water",
  "drinking water": "water",
  "ice": "ice",
  "ice cubes": "ice",
  "baraf": "ice",
  "barf": "ice",
  "rose water": "rose_water",
  "gulab jal": "rose_water",
  "rose essence": "rose_water",
  "panneer rose": "rose_water",
  "kewra water": "kewra_water",
  "kewra essence": "kewra_water",
  "screwpine water": "kewra_water",
  "kevda": "kewra_water",
  "edible silver leaf": "vark",
  "chandi ka vark": "vark",
  "silver vark": "vark",
  "varak": "vark",
  "edible silver": "vark",
  "pointed gourd": "pointed_gourd",
  "parwal": "pointed_gourd",
  "parval": "pointed_gourd",
  "potol": "pointed_gourd",
  "palwal": "pointed_gourd",
  "potala": "pointed_gourd",
  "kambupudalai": "pointed_gourd",
  "green potato": "pointed_gourd",
  "spiny gourd": "spiny_gourd",
  "kantola": "spiny_gourd",
  "kantoli": "spiny_gourd",
  "kakrol": "spiny_gourd",
  "kakora": "spiny_gourd",
  "ban karela": "spiny_gourd",
  "spine gourd": "spiny_gourd",
  "teasel gourd": "spiny_gourd",
  "aakakarakaya": "spiny_gourd",
  "madahagalakai": "spiny_gourd",
  "chayote": "chayote",
  "chow chow": "chayote",
  "chowchow": "chayote",
  "seemai kathirikai": "chayote",
  "bangalore brinjal": "chayote",
  "squash": "chayote",
  "iskus": "chayote",
  "chayote squash": "chayote",
  "merliton": "chayote",
  "sponge gourd": "sponge_gourd",
  "nenua": "sponge_gourd",
  "ghia tori": "sponge_gourd",
  "smooth gourd": "sponge_gourd",
  "loofah": "sponge_gourd",
  "sponge luffa": "sponge_gourd",
  "field beans": "field_beans",
  "val papdi": "field_beans",
  "hyacinth beans": "field_beans",
  "lablab": "field_beans",
  "avare kayi": "field_beans",
  "dolichos beans": "field_beans",
  "sword beans": "sword_beans",
  "jack beans": "sword_beans",
  "valavar": "sword_beans",
  "abai": "sword_beans",
  "tambada": "sword_beans",
  "canavalia": "sword_beans",
  "makhanchoti": "sword_beans",
  "winged beans": "winged_beans",
  "goa beans": "winged_beans",
  "four angled beans": "winged_beans",
  "dragon beans": "winged_beans",
  "princess beans": "winged_beans",
  "kalapidlu": "winged_beans",
  "long beans": "long_beans",
  "yardlong beans": "long_beans",
  "barbati": "long_beans",
  "achingapayar": "long_beans",
  "alasande": "long_beans",
  "snake beans": "long_beans",
  "cowpea beans": "long_beans",
  "bora": "long_beans",
  "edamame": "edamame",
  "green soybeans": "edamame",
  "soya beans": "edamame",
  "mukimame": "edamame",
  "asparagus": "asparagus",
  "shatavari": "asparagus",
  "sparrow grass": "asparagus",
  "aspargus": "asparagus",
  "celery": "celery",
  "ajmoda": "celery",
  "salari": "celery",
  "seleri": "celery",
  "ajwain ka patta": "celery",
  "leek": "leek",
  "leeks": "leek",
  "gandana": "leek",
  "leak": "leek",
  "artichoke": "artichoke",
  "globe artichoke": "artichoke",
  "hathichak": "artichoke",
  "artichock": "artichoke",
  "fennel bulb": "fennel_bulb",
  "finocchio": "fennel_bulb",
  "saunf bulb": "fennel_bulb",
  "florence fennel": "fennel_bulb",
  "fennal": "fennel_bulb",
  "bok choy": "bok_choy",
  "pak choi": "bok_choy",
  "pakchoi": "bok_choy",
  "chinese cabbage": "bok_choy",
  "bokchoy": "bok_choy",
  "buk choy": "bok_choy",
  "kale": "kale",
  "karam saag": "kale",
  "leaf cabbage": "kale",
  "curly kale": "kale",
  "borecole": "kale",
  "red cabbage": "red_cabbage",
  "purple cabbage": "red_cabbage",
  "lal patta gobi": "red_cabbage",
  "laal bandh gobi": "red_cabbage",
  "baby corn": "baby_corn",
  "chota bhutta": "baby_corn",
  "cornlets": "baby_corn",
  "young corn": "baby_corn",
  "babycorn": "baby_corn",
  "water chestnut": "water_chestnut",
  "singhara": "water_chestnut",
  "singhada": "water_chestnut",
  "paniphal": "water_chestnut",
  "water caltrop": "water_chestnut",
  "shingada": "water_chestnut",
  "lotus stem": "lotus_stem",
  "kamal kakdi": "lotus_stem",
  "bhein": "lotus_stem",
  "nadru": "lotus_stem",
  "bhe": "lotus_stem",
  "lotus root": "lotus_stem",
  "kamal nal": "lotus_stem",
  "thamarai thandu": "lotus_stem",
  "bamboo shoot": "bamboo_shoot",
  "bans": "bamboo_shoot",
  "bamboo shoots": "bamboo_shoot",
  "karil": "bamboo_shoot",
  "bashtenga": "bamboo_shoot",
  "moongil": "bamboo_shoot",
  "kalale": "bamboo_shoot",
  "sweet potato": "sweet_potato",
  "shakarkandi": "sweet_potato",
  "shakkarkand": "sweet_potato",
  "sakarkand": "sweet_potato",
  "ratala": "sweet_potato",
  "genasu": "sweet_potato",
  "sarkaraivalli kizhangu": "sweet_potato",
  "chilakada dumpa": "sweet_potato",
  "taro root": "taro_root",
  "arbi": "taro_root",
  "arvi": "taro_root",
  "colocasia": "taro_root",
  "seppankizhangu": "taro_root",
  "chembu": "taro_root",
  "kesuvina gadde": "taro_root",
  "chamadumpa": "taro_root",
  "ghuiya": "taro_root",
  "elephant foot yam": "elephant_foot_yam",
  "suran": "elephant_foot_yam",
  "jimikand": "elephant_foot_yam",
  "ol": "elephant_foot_yam",
  "senai kizhangu": "elephant_foot_yam",
  "chenai": "elephant_foot_yam",
  "zaminkand": "elephant_foot_yam",
  "suvarna gadde": "elephant_foot_yam",
  "purple yam": "purple_yam",
  "ratalu": "purple_yam",
  "kand": "purple_yam",
  "greater yam": "purple_yam",
  "ube": "purple_yam",
  "khamalu": "purple_yam",
  "raja ala": "purple_yam",
  "dioscorea": "purple_yam",
  "white yam": "white_yam",
  "yam": "white_yam",
  "valli kizhangu": "white_yam",
  "dioscorea alata": "white_yam",
  "raw jackfruit": "raw_jackfruit",
  "kathhal": "raw_jackfruit",
  "green jackfruit": "raw_jackfruit",
  "echor": "raw_jackfruit",
  "fanas": "raw_jackfruit",
  "palakaya": "raw_jackfruit",
  "halasinakai": "raw_jackfruit",
  "tender jackfruit": "raw_jackfruit",
  "banana flower": "banana_flower",
  "kele ka phool": "banana_flower",
  "mocha": "banana_flower",
  "vazhaipoo": "banana_flower",
  "balehoovu": "banana_flower",
  "arati puvvu": "banana_flower",
  "banana blossom": "banana_flower",
  "kesel phool": "banana_flower",
  "banana stem": "banana_stem",
  "kele ka tana": "banana_stem",
  "thor": "banana_stem",
  "vazhaithandu": "banana_stem",
  "baledindu": "banana_stem",
  "arati doota": "banana_stem",
  "plantain stem": "banana_stem",
  "mocha thad": "banana_stem",
  "cassava": "cassava",
  "tapioca": "cassava",
  "kappa": "cassava",
  "maravalli kizhangu": "cassava",
  "marcheeni": "cassava",
  "yuca": "cassava",
  "manioc": "cassava",
  "semiya kilangu": "cassava",
  "turnip": "turnip",
  "shalgam": "turnip",
  "salgam": "turnip",
  "shaljam": "turnip",
  "turnap": "turnip",
  "kohlrabi": "kohlrabi",
  "ganth gobi": "kohlrabi",
  "knol khol": "kohlrabi",
  "navalkol": "kohlrabi",
  "german turnip": "kohlrabi",
  "gantha kobi": "kohlrabi",
  "nookal": "kohlrabi",
  "kohl rabi": "kohlrabi",
  "parsnip": "parsnip",
  "white carrot": "parsnip",
  "parsnp": "parsnip",
  "green tomato": "green_tomato",
  "hara tamatar": "green_tomato",
  "kacha tamatar": "green_tomato",
  "unripe tomato": "green_tomato",
  "sun dried tomato": "sun_dried_tomato",
  "sundried tomato": "sun_dried_tomato",
  "dried tomato": "sun_dried_tomato",
  "sukha tamatar": "sun_dried_tomato",
  "olives": "olives",
  "jaitun": "olives",
  "zaitoon": "olives",
  "olive": "olives",
  "black olives": "olives",
  "green olives": "olives",
  "gherkins": "gherkins",
  "kakdi achar": "gherkins",
  "baby cucumber": "gherkins",
  "cornichon": "gherkins",
  "pickling cucumber": "gherkins",
  "gherkin": "gherkins",
  "jalapeno": "jalapeno",
  "jalapeno pepper": "jalapeno",
  "halapeno": "jalapeno",
  "mexican chilli": "jalapeno",
  "green jalapeno": "jalapeno",
  "celeriac": "celeriac",
  "celery root": "celeriac",
  "knob celery": "celeriac",
  "turnip rooted celery": "celeriac",
  "savoy cabbage": "savoy_cabbage",
  "curly cabbage": "savoy_cabbage",
  "savoy": "savoy_cabbage",
  "crinkled cabbage": "savoy_cabbage",
  "brussels sprouts": "brussels_sprouts",
  "chote patta gobi": "brussels_sprouts",
  "mini cabbage": "brussels_sprouts",
  "brussel sprouts": "brussels_sprouts",
  "snow peas": "snow_peas",
  "chinese peas": "snow_peas",
  "mangetout": "snow_peas",
  "flat peas": "snow_peas",
  "sugar peas": "snow_peas",
  "sugar snap peas": "sugar_snap_peas",
  "snap peas": "sugar_snap_peas",
  "mitha matar": "sugar_snap_peas",
  "tomatillo": "tomatillo",
  "mexican husk tomato": "tomatillo",
  "husk tomato": "tomatillo",
  "ground cherry": "tomatillo",
  "red bell pepper": "red_bell_pepper",
  "lal shimla mirch": "red_bell_pepper",
  "red capsicum": "red_bell_pepper",
  "laal shimla": "red_bell_pepper",
  "red pepper": "red_bell_pepper",
  "yellow bell pepper": "yellow_bell_pepper",
  "peeli shimla mirch": "yellow_bell_pepper",
  "yellow capsicum": "yellow_bell_pepper",
  "peela shimla": "yellow_bell_pepper",
  "yellow pepper": "yellow_bell_pepper",
  "fingerroot": "fingerroot",
  "chinese ginger": "fingerroot",
  "krachai": "fingerroot",
  "lesser galangal": "fingerroot",
  "temu kunci": "fingerroot",
  "galangal": "galangal",
  "kulanjan": "galangal",
  "thai ginger": "galangal",
  "blue ginger": "galangal",
  "laos root": "galangal",
  "kulinjan": "galangal",
  "fresh turmeric": "fresh_turmeric",
  "kachi haldi": "fresh_turmeric",
  "raw turmeric": "fresh_turmeric",
  "green turmeric": "fresh_turmeric",
  "gilli haldi": "fresh_turmeric",
  "mango ginger": "mango_ginger",
  "amba haldi": "mango_ginger",
  "mavina shunti": "mango_ginger",
  "manga inji": "mango_ginger",
  "aam adrak": "mango_ginger",
  "amragandhi": "mango_ginger",
  "black radish": "black_radish",
  "kali mooli": "black_radish",
  "black mooli": "black_radish",
  "spanish radish": "black_radish",
  "rutabaga": "rutabaga",
  "swede": "rutabaga",
  "swedish turnip": "rutabaga",
  "yellow turnip": "rutabaga",
  "neep": "rutabaga",
  "jerusalem artichoke": "jerusalem_artichoke",
  "sunchoke": "jerusalem_artichoke",
  "earth apple": "jerusalem_artichoke",
  "sunroot": "jerusalem_artichoke",
  "topinambur": "jerusalem_artichoke",
  "horseradish": "horseradish",
  "horse radish": "horseradish",
  "red cole": "horseradish",
  "sahjan jad": "horseradish",
  "cluster fig": "cluster_fig",
  "gular": "cluster_fig",
  "athi pazham": "cluster_fig",
  "umbar": "cluster_fig",
  "atti": "cluster_fig",
  "goolar": "cluster_fig",
  "dumbar": "cluster_fig",
  "malabar spinach": "malabar_spinach",
  "poi saag": "malabar_spinach",
  "basale soppu": "malabar_spinach",
  "bachhali kura": "malabar_spinach",
  "mayalu": "malabar_spinach",
  "ceylon spinach": "malabar_spinach",
  "vine spinach": "malabar_spinach",
  "poi": "malabar_spinach",
  "water spinach": "water_spinach",
  "kalmi saag": "water_spinach",
  "kangkong": "water_spinach",
  "nali saag": "water_spinach",
  "river spinach": "water_spinach",
  "kankun": "water_spinach",
  "kolmou": "water_spinach",
  "purslane": "purslane",
  "kulfa": "purslane",
  "luni bhaji": "purslane",
  "paruppu keerai": "purslane",
  "gangavalli kura": "purslane",
  "sanhti": "purslane",
  "ghol": "purslane",
  "pursley": "purslane",
  "swiss chard": "swiss_chard",
  "chard": "swiss_chard",
  "silverbeet": "swiss_chard",
  "leaf beet": "swiss_chard",
  "seakale beet": "swiss_chard",
  "arugula": "arugula",
  "rocket": "arugula",
  "rocket leaves": "arugula",
  "rucola": "arugula",
  "roquette": "arugula",
  "taramira": "arugula",
  "radish greens": "radish_greens",
  "mooli ke patte": "radish_greens",
  "mullangi keerai": "radish_greens",
  "radish leaves": "radish_greens",
  "mooli saag": "radish_greens",
  "tamarind leaves": "tamarind_leaves",
  "imli ke patte": "tamarind_leaves",
  "puli ilai": "tamarind_leaves",
  "chinta chiguru": "tamarind_leaves",
  "hunase soppu": "tamarind_leaves",
  "tamarind shoots": "tamarind_leaves",
  "agathi leaves": "agathi_leaves",
  "agathi keerai": "agathi_leaves",
  "august tree leaves": "agathi_leaves",
  "hummingbird tree": "agathi_leaves",
  "agasti": "agathi_leaves",
  "avisa kura": "agathi_leaves",
  "agase soppu": "agathi_leaves",
  "ponnanganni greens": "ponnanganni_greens",
  "ponnanganni keerai": "ponnanganni_greens",
  "sessile joyweed": "ponnanganni_greens",
  "mukunuwenna": "ponnanganni_greens",
  "matsyakshi": "ponnanganni_greens",
  "honnaganne soppu": "ponnanganni_greens",
  "pumpkin leaves": "pumpkin_leaves",
  "kaddu ke patte": "pumpkin_leaves",
  "parangikai keerai": "pumpkin_leaves",
  "kumbalakai soppu": "pumpkin_leaves",
  "squash greens": "pumpkin_leaves",
  "kaddu saag": "pumpkin_leaves",
  "lemongrass": "lemongrass",
  "gavati chaha": "lemongrass",
  "bhustrina": "lemongrass",
  "lemon grass": "lemongrass",
  "sera": "lemongrass",
  "karpoorapullu": "lemongrass",
  "majjige hullu": "lemongrass",
  "nimmagaddi": "lemongrass",
  "fever grass": "lemongrass",
  "kaffir lime leaf": "kaffir_lime_leaf",
  "makrut lime leaf": "kaffir_lime_leaf",
  "thai lime leaf": "kaffir_lime_leaf",
  "kaffir leaves": "kaffir_lime_leaf",
  "limau purut": "kaffir_lime_leaf",
  "celery leaf": "celery_leaf",
  "ajmoda patta": "celery_leaf",
  "celery greens": "celery_leaf",
  "leaf celery": "celery_leaf",
  "salari patta": "celery_leaf",
  "sage": "sage",
  "salvia": "sage",
  "sefakuss": "sage",
  "kamarkas patta": "sage",
  "saage": "sage",
  "marjoram": "marjoram",
  "sweet marjoram": "marjoram",
  "marwa": "marjoram",
  "majorana": "marjoram",
  "marua": "marjoram",
  "chives": "chives",
  "onion chives": "chives",
  "chinese chives": "chives",
  "garlic chives": "chives",
  "hara pyaz patti": "chives",
  "chibs": "chives",
  "tarragon": "tarragon",
  "estragon": "tarragon",
  "nagdona": "tarragon",
  "french tarragon": "tarragon",
  "tarragan": "tarragon",
  "thai basil": "thai_basil",
  "horapha": "thai_basil",
  "sweet thai basil": "thai_basil",
  "asian basil": "thai_basil",
  "bai horapha": "thai_basil",
  "holy basil": "holy_basil",
  "tulsi": "holy_basil",
  "tulasi": "holy_basil",
  "sacred basil": "holy_basil",
  "krishna tulsi": "holy_basil",
  "rama tulsi": "holy_basil",
  "sawtooth coriander": "sawtooth_coriander",
  "culantro": "sawtooth_coriander",
  "ban dhania": "sawtooth_coriander",
  "mexican coriander": "sawtooth_coriander",
  "saw leaf herb": "sawtooth_coriander",
  "long coriander": "sawtooth_coriander",
  "recao": "sawtooth_coriander",
  "winter savory": "winter_savory",
  "savory": "winter_savory",
  "mountain savory": "winter_savory",
  "saturja": "winter_savory",
  "borage": "borage",
  "gaozaban": "borage",
  "starflower": "borage",
  "gojihva": "borage",
  "borag": "borage",
  "epazote": "epazote",
  "mexican tea": "epazote",
  "wormseed": "epazote",
  "jesuit tea": "epazote",
  "epasote": "epazote",
  "vietnamese coriander": "vietnamese_coriander",
  "rau ram": "vietnamese_coriander",
  "laksa leaf": "vietnamese_coriander",
  "vietnamese mint": "vietnamese_coriander",
  "hot mint": "vietnamese_coriander",
  "shiso": "shiso",
  "perilla": "shiso",
  "beefsteak plant": "shiso",
  "japanese basil": "shiso",
  "bhanjira": "shiso",
  "jamun": "jamun",
  "java plum": "jamun",
  "black plum": "jamun",
  "indian blackberry": "jamun",
  "malabar plum": "jamun",
  "jambul": "jamun",
  "jambolan": "jamun",
  "neredu": "jamun",
  "naval pazham": "jamun",
  "nerale hannu": "jamun",
  "kala jamun": "jamun",
  "jaman": "jamun",
  "ber": "ber",
  "indian jujube": "ber",
  "indian plum": "ber",
  "chinese date": "ber",
  "bor": "ber",
  "bordoi": "ber",
  "regi pandu": "ber",
  "elanthai pazham": "ber",
  "yelchi hannu": "ber",
  "kul": "ber",
  "jujube indian": "ber",
  "bair": "ber",
  "amla": "amla",
  "indian gooseberry": "amla",
  "gooseberry indian": "amla",
  "nellikai": "amla",
  "nellikkai": "amla",
  "usirikaya": "amla",
  "amalaki": "amla",
  "aonla": "amla",
  "awla": "amla",
  "amlaki": "amla",
  "nelli": "amla",
  "wood apple": "wood_apple",
  "kaitha": "wood_apple",
  "kath bel": "wood_apple",
  "velam pazham": "wood_apple",
  "wood apple fruit": "wood_apple",
  "kapittha": "wood_apple",
  "bilin": "wood_apple",
  "vilam palam": "wood_apple",
  "bael": "bael",
  "bel": "bael",
  "bilva": "bael",
  "stone apple": "bael",
  "golden apple": "bael",
  "bengal quince": "bael",
  "bel fruit": "bael",
  "vilvam": "bael",
  "maredu": "bael",
  "bilwa": "bael",
  "sriphal": "bael",
  "tamarind fruit": "tamarind_fruit",
  "chinch": "tamarind_fruit",
  "tetul": "tamarind_fruit",
  "amli": "tamarind_fruit",
  "imli fruit": "tamarind_fruit",
  "tamrind": "tamarind_fruit",
  "sweet tamarind": "sweet_tamarind",
  "meethi imli": "sweet_tamarind",
  "thai tamarind": "sweet_tamarind",
  "sweet imli": "sweet_tamarind",
  "madhura puli": "sweet_tamarind",
  "sweet tamarind fruit": "sweet_tamarind",
  "star fruit": "star_fruit",
  "carambola": "star_fruit",
  "kamrakh": "star_fruit",
  "kamrak": "star_fruit",
  "star apple fruit": "star_fruit",
  "tamarta": "star_fruit",
  "ambanam": "star_fruit",
  "karambolam": "star_fruit",
  "starfruit": "star_fruit",
  "mangosteen": "mangosteen",
  "mangostein": "mangosteen",
  "kaattampi": "mangosteen",
  "mangustan": "mangosteen",
  "ivaruga pazham": "mangosteen",
  "queen of fruits": "mangosteen",
  "mangoosteen": "mangosteen",
  "rambutan": "rambutan",
  "rambutaan": "rambutan",
  "hairy lychee": "rambutan",
  "rambuttan": "rambutan",
  "rambootan": "rambutan",
  "dragon fruit": "dragon_fruit",
  "pitaya": "dragon_fruit",
  "pitahaya": "dragon_fruit",
  "kamalam": "dragon_fruit",
  "dragonfruit": "dragon_fruit",
  "pink dragon fruit": "dragon_fruit",
  "strawberry pear": "dragon_fruit",
  "passion fruit": "passion_fruit",
  "passionfruit": "passion_fruit",
  "krishna phal": "passion_fruit",
  "passion fruit purple": "passion_fruit",
  "passion": "passion_fruit",
  "granadilla": "passion_fruit",
  "passion phal": "passion_fruit",
  "longan": "longan",
  "longaan": "longan",
  "dragon eye": "longan",
  "longan fruit": "longan",
  "lungan": "longan",
  "dragons eye": "longan",
  "phalsa": "phalsa",
  "falsa": "phalsa",
  "phalsa berry": "phalsa",
  "sherbet berry": "phalsa",
  "grewia": "phalsa",
  "phalsey": "phalsa",
  "palsa": "phalsa",
  "mulberry": "mulberry",
  "shahtoot": "mulberry",
  "shahtut": "mulberry",
  "tutti": "mulberry",
  "mulberi": "mulberry",
  "hippunerale": "mulberry",
  "mursberi": "mulberry",
  "kambli pazham": "mulberry",
  "toot": "mulberry",
  "mulburry": "mulberry",
  "fresh fig": "fresh_fig",
  "anjeer fresh": "fresh_fig",
  "fig fresh": "fresh_fig",
  "anjura": "fresh_fig",
  "fresh anjeer": "fresh_fig",
  "plum": "plum",
  "aloobukhara fresh": "plum",
  "alu bukhara": "plum",
  "aloo bukhara": "plum",
  "plum fruit": "plum",
  "aalu bukhara": "plum",
  "plam": "plum",
  "peach": "peach",
  "aadu": "peach",
  "aaru": "peach",
  "peech": "peach",
  "aroo": "peach",
  "peach fruit": "peach",
  "arru": "peach",
  "peache": "peach",
  "fresh apricot": "fresh_apricot",
  "khubani fresh": "fresh_apricot",
  "jardalu fresh": "fresh_apricot",
  "zardalu": "fresh_apricot",
  "fresh khubani": "fresh_apricot",
  "apricot fresh": "fresh_apricot",
  "khurmani fresh": "fresh_apricot",
  "cherry": "cherry",
  "cheri": "cherry",
  "cherry fruit": "cherry",
  "red cherry": "cherry",
  "cherries": "cherry",
  "blackberry": "blackberry",
  "black berry": "blackberry",
  "blackberi": "blackberry",
  "black berries": "blackberry",
  "brambleberry": "blackberry",
  "blueberry": "blueberry",
  "blue berry": "blueberry",
  "blueberi": "blueberry",
  "blue berries": "blueberry",
  "neelbadri": "blueberry",
  "raspberry": "raspberry",
  "rasberry": "raspberry",
  "red raspberry": "raspberry",
  "raspberi": "raspberry",
  "ras berry": "raspberry",
  "rasbhari": "raspberry",
  "cranberry": "cranberry",
  "cran berry": "cranberry",
  "cranberi": "cranberry",
  "karonda": "karonda",
  "carissa": "karonda",
  "christ thorn": "karonda",
  "bengal currant": "karonda",
  "kalakai": "karonda",
  "vakkay": "karonda",
  "karvanda": "karonda",
  "koromcha": "karonda",
  "karaunda": "karonda",
  "sugarcane": "sugarcane",
  "ganna": "sugarcane",
  "ikshu": "sugarcane",
  "cheruku": "sugarcane",
  "karumbu": "sugarcane",
  "kabbu": "sugarcane",
  "aakh": "sugarcane",
  "sugar cane": "sugarcane",
  "ganne": "sugarcane",
  "us": "sugarcane",
  "ice apple": "tadgola",
  "tadgola": "tadgola",
  "palm fruit": "tadgola",
  "nungu": "tadgola",
  "taati munjalu": "tadgola",
  "toddy palm fruit": "tadgola",
  "taal": "tadgola",
  "munjal": "tadgola",
  "tale hannu": "tadgola",
  "taad gola": "tadgola",
  "breadfruit": "breadfruit",
  "bread fruit": "breadfruit",
  "kadachakka": "breadfruit",
  "jeegujje": "breadfruit",
  "seema panasa": "breadfruit",
  "neer phanas": "breadfruit",
  "barahphal": "breadfruit",
  "grapefruit": "grapefruit",
  "grape fruit": "grapefruit",
  "chakotra": "grapefruit",
  "grapefruit fruit": "grapefruit",
  "gulgul": "grapefruit",
  "pomelo": "pomelo",
  "sweet lime large": "pomelo",
  "bambolmas": "pomelo",
  "pumelo": "pomelo",
  "shaddock": "pomelo",
  "batabi lebu": "pomelo",
  "pamparmas": "pomelo",
  "mandarin orange": "mandarin",
  "mandarin": "mandarin",
  "tangerine": "mandarin",
  "loose jacket orange": "mandarin",
  "kinnow": "kinnow",
  "kinno": "kinnow",
  "kinu": "kinnow",
  "kinnow orange": "kinnow",
  "hybrid mandarin": "kinnow",
  "kinnow fruit": "kinnow",
  "malta orange": "malta_orange",
  "malta": "malta_orange",
  "blood orange malta": "malta_orange",
  "malta fruit": "malta_orange",
  "malta narangi": "malta_orange",
  "honeydew melon": "honeydew_melon",
  "honey dew": "honeydew_melon",
  "honeydew": "honeydew_melon",
  "green melon": "honeydew_melon",
  "sarda melon": "honeydew_melon",
  "honeydew fruit": "honeydew_melon",
  "tendu fruit": "tendu_fruit",
  "tendu": "tendu_fruit",
  "gaab": "tendu_fruit",
  "kendu": "tendu_fruit",
  "timburni": "tendu_fruit",
  "tembru": "tendu_fruit",
  "persimmon": "persimmon",
  "japani phal": "persimmon",
  "sharon fruit": "persimmon",
  "amlok": "persimmon",
  "persimon": "persimmon",
  "kaki fruit": "persimmon",
  "japani fal": "persimmon",
  "ramphal": "ramphal",
  "bullock heart": "ramphal",
  "ram phal": "ramphal",
  "ramfal": "ramphal",
  "ramphal fruit": "ramphal",
  "ramaphalam": "ramphal",
  "wild custard apple": "ramphal",
  "soursop": "soursop",
  "lakshman phal": "soursop",
  "mullu seetha": "soursop",
  "graviola": "soursop",
  "hanuman phal": "soursop",
  "soursop fruit": "soursop",
  "laxman phal": "soursop",
  "egg fruit": "egg_fruit",
  "canistel": "egg_fruit",
  "eggfruit": "egg_fruit",
  "yellow sapote": "egg_fruit",
  "rose apple": "rose_apple",
  "gulab jamun fruit": "rose_apple",
  "jamrul": "rose_apple",
  "champoo": "rose_apple",
  "chambakka": "rose_apple",
  "panneer pazham": "rose_apple",
  "rose apple fruit": "rose_apple",
  "wax apple": "rose_apple",
  "jambu": "rose_apple",
  "water apple": "rose_apple",
  "jamfal": "rose_apple",
  "kair": "kair",
  "ker": "kair",
  "kerda": "kair",
  "caper berry": "kair",
  "teent": "kair",
  "kair berry": "kair",
  "capparis": "kair",
  "gunda": "gunda",
  "lasoda": "gunda",
  "lasora": "gunda",
  "gum berry": "gunda",
  "glue berry": "gunda",
  "gonda": "gunda",
  "gunda fruit": "gunda",
  "bhokar": "gunda",
  "monkey jack": "monkey_jack",
  "lakoocha": "monkey_jack",
  "barhal": "monkey_jack",
  "lakuchi": "monkey_jack",
  "badahar": "monkey_jack",
  "dahu": "monkey_jack",
  "wotamba": "monkey_jack",
  "santol": "santol",
  "sentul": "santol",
  "cotton fruit": "santol",
  "santol fruit": "santol",
  "sayai": "santol",
  "wild mangosteen": "santol",
  "pink guava": "pink_guava",
  "red guava": "pink_guava",
  "peru pink": "pink_guava",
  "amrood pink": "pink_guava",
  "fresh date": "fresh_date",
  "fresh khajoor": "fresh_date",
  "khalal": "fresh_date",
  "rutab": "fresh_date",
  "wet dates": "fresh_date",
  "fresh dates": "fresh_date",
  "khajur fresh": "fresh_date",
  "apple ber": "apple_ber",
  "thai ber": "apple_ber",
  "apple bor": "apple_ber",
  "big ber": "apple_ber",
  "kashmiri ber": "apple_ber",
  "apple jujube": "apple_ber",
  "makhana": "makhana",
  "fox nut": "makhana",
  "foxnut": "makhana",
  "lotus seed pop": "makhana",
  "phool makhana": "makhana",
  "gorgon nut": "makhana",
  "makhane": "makhana",
  "puffed lotus seed": "makhana",
  "chironji": "chironji",
  "charoli": "chironji",
  "chiraunji": "chironji",
  "charoli nut": "chironji",
  "chironji seed": "chironji",
  "sara nut": "chironji",
  "priyal": "chironji",
  "char nut": "chironji",
  "chironjee": "chironji",
  "tutti frutti": "tutti_frutti",
  "tuttifrutti": "tutti_frutti",
  "candied papaya": "tutti_frutti",
  "candied fruit": "tutti_frutti",
  "mixed candied fruit": "tutti_frutti",
  "tutti fruity": "tutti_frutti",
  "tooti frooti": "tutti_frutti",
  "mixed peel": "tutti_frutti",
  "candied cherry": "candied_cherry",
  "glace cherry": "candied_cherry",
  "glazed cherry": "candied_cherry",
  "candied cherries": "candied_cherry",
  "cocktail cherry": "candied_cherry",
  "preserved cherry": "candied_cherry",
  "dried cranberry": "dried_cranberry",
  "craisins": "dried_cranberry",
  "dried cranberries": "dried_cranberry",
  "sweetened cranberry": "dried_cranberry",
  "cranberry dried": "dried_cranberry",
  "dried blueberry": "dried_blueberry",
  "dried blueberries": "dried_blueberry",
  "blueberry dried": "dried_blueberry",
  "sweetened blueberry": "dried_blueberry",
  "dried kiwi": "dried_kiwi",
  "kiwi dried": "dried_kiwi",
  "dehydrated kiwi": "dried_kiwi",
  "dried kiwi slices": "dried_kiwi",
  "dried mango": "dried_mango",
  "mango dried": "dried_mango",
  "aam sukha": "dried_mango",
  "dehydrated mango": "dried_mango",
  "dried pineapple": "dried_pineapple",
  "pineapple dried": "dried_pineapple",
  "dried pineapple rings": "dried_pineapple",
  "dehydrated pineapple": "dried_pineapple",
  "dried papaya": "dried_papaya",
  "papaya dried": "dried_papaya",
  "dried papaya cubes": "dried_papaya",
  "dehydrated papaya": "dried_papaya",
  "dried jamun": "dried_jamun",
  "jamun dried": "dried_jamun",
  "dried java plum": "dried_jamun",
  "sukha jamun": "dried_jamun",
  "dried amla": "dried_amla",
  "amla dried": "dried_amla",
  "dried gooseberry": "dried_amla",
  "sukha amla": "dried_amla",
  "dehydrated nellikai": "dried_amla",
  "black raisin": "black_raisin",
  "black raisins": "black_raisin",
  "kali kishmish": "black_raisin",
  "black kishmish": "black_raisin",
  "dried black grape": "black_raisin",
  "munakka": "munakka",
  "large raisin": "munakka",
  "munaqqa": "munakka",
  "manukka": "munakka",
  "big raisin": "munakka",
  "seeded raisin": "munakka",
  "drakshi big": "munakka",
  "dried date": "dried_date",
  "chuara": "dried_date",
  "chhuhara": "dried_date",
  "dried dates": "dried_date",
  "kharek": "dried_date",
  "pind khajoor": "dried_date",
  "dry khajur": "dried_date",
  "sukha khajoor": "dried_date",
  "ajwa date": "ajwa_date",
  "ajwa": "ajwa_date",
  "ajwah": "ajwa_date",
  "ajwa khajoor": "ajwa_date",
  "madina date": "ajwa_date",
  "ajwa dates": "ajwa_date",
  "medjool date": "medjool_date",
  "medjool": "medjool_date",
  "mejdool": "medjool_date",
  "medjoul date": "medjool_date",
  "king date": "medjool_date",
  "medjool dates": "medjool_date",
  "kimia date": "kimia_date",
  "kimia": "kimia_date",
  "kalmi date": "kimia_date",
  "irani date": "kimia_date",
  "kimia dates": "kimia_date",
  "mazafati date": "kimia_date",
  "turkish apricot": "turkish_apricot",
  "turkish khubani": "turkish_apricot",
  "jumbo apricot": "turkish_apricot",
  "dried turkish apricot": "turkish_apricot",
  "seedless apricot": "turkish_apricot",
  "khubani turkish": "turkish_apricot",
  "dried mulberry": "dried_mulberry",
  "shahtoot dry": "dried_mulberry",
  "dried shahtoot": "dried_mulberry",
  "mulberry dried": "dried_mulberry",
  "white mulberry dried": "dried_mulberry",
  "sukha toot": "dried_mulberry",
  "amla candy": "amla_candy",
  "sweet amla": "amla_candy",
  "amla murabba dry": "amla_candy",
  "candied amla": "amla_candy",
  "amla supari": "amla_candy",
  "caraway seeds": "shahi_jeera",
  "shahi jeera": "shahi_jeera",
  "shah jeera": "shahi_jeera",
  "royal cumin": "shahi_jeera",
  "siya jeera": "shahi_jeera",
  "shahjeera": "shahi_jeera",
  "caraway": "shahi_jeera",
  "dill seeds": "dill_seeds",
  "suva": "dill_seeds",
  "sabasige seeds": "dill_seeds",
  "anethi": "dill_seeds",
  "dill seed": "dill_seeds",
  "celery seeds": "celery_seeds",
  "ajmoda seeds": "celery_seeds",
  "randhuni": "celery_seeds",
  "bari ajwain": "celery_seeds",
  "celery seed": "celery_seeds",
  "dried pomegranate seeds": "dried_pomegranate_seeds",
  "anardana": "dried_pomegranate_seeds",
  "anar dana": "dried_pomegranate_seeds",
  "dried anar": "dried_pomegranate_seeds",
  "pomegranate seed powder": "dried_pomegranate_seeds",
  "anardana powder": "dried_pomegranate_seeds",
  "dadima": "dried_pomegranate_seeds",
  "allspice": "allspice",
  "pimento": "allspice",
  "jamaica pepper": "allspice",
  "seet chini": "allspice",
  "all spice": "allspice",
  "paprika": "paprika",
  "sweet paprika": "paprika",
  "deghi mirch": "paprika",
  "paprica": "paprika",
  "red paprika": "paprika",
  "cayenne pepper": "cayenne_pepper",
  "cayenne": "cayenne_pepper",
  "cayenne chilli": "cayenne_pepper",
  "ground cayenne": "cayenne_pepper",
  "kayenne": "cayenne_pepper",
  "hot pepper powder": "cayenne_pepper",
  "smoked paprika": "smoked_paprika",
  "pimenton": "smoked_paprika",
  "spanish paprika": "smoked_paprika",
  "pimenton de la vera": "smoked_paprika",
  "smoke paprika": "smoked_paprika",
  "smoky paprika": "smoked_paprika",
  "juniper berries": "juniper_berries",
  "juniper": "juniper_berries",
  "hapusha": "juniper_berries",
  "aaraar": "juniper_berries",
  "abhal": "juniper_berries",
  "havuber": "juniper_berries",
  "juniper berry": "juniper_berries",
  "sumac": "sumac",
  "sumaq": "sumac",
  "summaq": "sumac",
  "sumac powder": "sumac",
  "souma": "sumac",
  "za'atar": "zaatar",
  "zatar": "zaatar",
  "zaatar": "zaatar",
  "zahtar": "zaatar",
  "zaytar": "zaatar",
  "middle eastern herb blend": "zaatar",
  "dried marjoram": "dried_marjoram",
  "dried marwa": "dried_marjoram",
  "sweet marjoram dried": "dried_marjoram",
  "marjoram leaves dried": "dried_marjoram",
  "dried thyme": "dried_thyme",
  "thyme dried": "dried_thyme",
  "hasha": "dried_thyme",
  "thyme leaves dried": "dried_thyme",
  "dried basil": "dried_basil",
  "sweet basil dried": "dried_basil",
  "basil leaves dried": "dried_basil",
  "dried mint": "dried_mint",
  "pudina dried": "dried_mint",
  "sukha pudina": "dried_mint",
  "mint flakes": "dried_mint",
  "dried pudina": "dried_mint",
  "podina dry": "dried_mint",
  "long pepper": "long_pepper",
  "pippali": "long_pepper",
  "pipli": "long_pepper",
  "peepli": "long_pepper",
  "thippili": "long_pepper",
  "hippali": "long_pepper",
  "modi": "long_pepper",
  "pipli mirch": "long_pepper",
  "cubeb pepper": "cubeb",
  "kabab chini": "cubeb",
  "kababchini": "cubeb",
  "tailed pepper": "cubeb",
  "sheetal chini": "cubeb",
  "val milagu": "cubeb",
  "grains of paradise": "grains_of_paradise",
  "melegueta pepper": "grains_of_paradise",
  "alligator pepper": "grains_of_paradise",
  "guinea grains": "grains_of_paradise",
  "paradise seeds": "grains_of_paradise",
  "kapok buds": "marathi_moggu",
  "marathi moggu": "marathi_moggu",
  "kapok bud": "marathi_moggu",
  "silk cotton bud": "marathi_moggu",
  "marathi mogu": "marathi_moggu",
  "kapasi": "marathi_moggu",
  "licorice root": "licorice_root",
  "mulethi": "licorice_root",
  "mulhati": "licorice_root",
  "jeshthamadh": "licorice_root",
  "yashtimadhu": "licorice_root",
  "liquorice": "licorice_root",
  "atimadhuram": "licorice_root",
  "jethimadh": "licorice_root",
  "mulaithi": "licorice_root",
  "vanilla bean": "vanilla_bean",
  "vanilla pod": "vanilla_bean",
  "vanilla beans": "vanilla_bean",
  "vanilla stick": "vanilla_bean",
  "dried mango slices": "amchur_whole",
  "amchur khatai": "amchur_whole",
  "khatai": "amchur_whole",
  "dried mango slice": "amchur_whole",
  "sukha aam": "amchur_whole",
  "dried rose petals": "dried_rose_petals",
  "gulab patti": "dried_rose_petals",
  "sukhe gulab": "dried_rose_petals",
  "rose petals dried": "dried_rose_petals",
  "gulab ki pankhudi": "dried_rose_petals",
  "sichuan pepper": "tirphal",
  "teppal": "tirphal",
  "tirphal": "tirphal",
  "szechuan pepper": "tirphal",
  "timur": "tirphal",
  "triphal": "tirphal",
  "prickly ash": "tirphal",
  "goda masala": "goda_masala",
  "sweet masala maharashtra": "goda_masala",
  "goda": "goda_masala",
  "maharashtrian masala": "goda_masala",
  "chettinad masala": "chettinad_masala",
  "chettinadu masala": "chettinad_masala",
  "chettinad powder": "chettinad_masala",
  "chettinad spice mix": "chettinad_masala",
  "kolhapuri masala": "kolhapuri_masala",
  "kanda lasun masala": "kolhapuri_masala",
  "kolhapuri kanda lasun": "kolhapuri_masala",
  "kolhapuri spice": "kolhapuri_masala",
  "malvani masala": "malvani_masala",
  "malwani masala": "malvani_masala",
  "konkani masala": "malvani_masala",
  "malvani spice mix": "malvani_masala",
  "panch phoron": "panch_phoron",
  "panch phutana": "panch_phoron",
  "panch phoran": "panch_phoron",
  "bengali five spice": "panch_phoron",
  "paanch phoron": "panch_phoron",
  "panchphoran": "panch_phoron",
  "bafat powder": "bafat_powder",
  "bafat masala": "bafat_powder",
  "mangalorean bafat": "bafat_powder",
  "bafat pito": "bafat_powder",
  "gunpowder podi": "gunpowder_podi",
  "idli podi": "gunpowder_podi",
  "gunpowder": "gunpowder_podi",
  "chutney podi": "gunpowder_podi",
  "milagai podi": "milagai_podi",
  "molagai podi": "milagai_podi",
  "chilli podi": "milagai_podi",
  "dosa podi": "milagai_podi",
  "milaga podi": "milagai_podi",
  "curry powder": "curry_powder",
  "curry masala": "curry_powder",
  "british curry powder": "curry_powder",
  "mild curry powder": "curry_powder",
  "madras curry powder": "madras_curry_powder",
  "madras masala": "madras_curry_powder",
  "hot curry powder": "madras_curry_powder",
  "madras curry": "madras_curry_powder",
  "shahi garam masala": "shahi_garam_masala",
  "royal garam masala": "shahi_garam_masala",
  "shahi masala": "shahi_garam_masala",
  "mughlai garam masala": "shahi_garam_masala",
  "butter chicken masala": "butter_chicken_masala",
  "makhani masala": "butter_chicken_masala",
  "murgh makhani masala": "butter_chicken_masala",
  "butter masala mix": "butter_chicken_masala",
  "chole masala": "chole_masala",
  "chana masala": "chole_masala",
  "chhole masala": "chole_masala",
  "chickpea masala": "chole_masala",
  "pindi chole masala": "chole_masala",
  "kala masala": "kala_masala",
  "black masala maharashtra": "kala_masala",
  "kaala masala": "kala_masala",
  "kala spice mix": "kala_masala",
  "dhansak masala": "dhansak_masala",
  "parsi dhansak masala": "dhansak_masala",
  "dhansak powder": "dhansak_masala",
  "dhanshak masala": "dhansak_masala",
  "xacuti masala": "xacuti_masala",
  "goan xacuti": "xacuti_masala",
  "shakuti masala": "xacuti_masala",
  "xacuti powder": "xacuti_masala",
  "rajma masala": "rajma_masala",
  "kidney bean masala": "rajma_masala",
  "rajmah masala": "rajma_masala",
  "rajma spice mix": "rajma_masala",
  "sabji masala": "sabji_masala",
  "sabzi masala": "sabji_masala",
  "subzi masala": "sabji_masala",
  "mixed vegetable masala": "sabji_masala",
  "paneer masala": "paneer_masala",
  "shahi paneer masala": "paneer_masala",
  "paneer butter masala mix": "paneer_masala",
  "cottage cheese masala": "paneer_masala",
  "kadhai masala": "kadhai_masala",
  "karahi masala": "kadhai_masala",
  "kadai masala": "kadhai_masala",
  "kadhai spice mix": "kadhai_masala",
  "paruppu podi": "paruppu_podi",
  "dal podi": "paruppu_podi",
  "kandi podi": "paruppu_podi",
  "lentil podi": "paruppu_podi",
  "paruppu powder": "paruppu_podi",
  "curry leaf podi": "curry_leaf_podi",
  "karuveppilai podi": "curry_leaf_podi",
  "curry leaf powder": "curry_leaf_podi",
  "kadi patta podi": "curry_leaf_podi",
  "karivepaku podi": "curry_leaf_podi",
  "vangi bath masala": "vangi_bath_masala",
  "vangibath powder": "vangi_bath_masala",
  "brinjal rice masala": "vangi_bath_masala",
  "vangi bhath masala": "vangi_bath_masala",
  "puliyogare powder": "puliyogare_masala",
  "puliyodharai powder": "puliyogare_masala",
  "tamarind rice powder": "puliyogare_masala",
  "pulihora masala": "puliyogare_masala",
  "bisi bele bath masala": "bisi_bele_bath_masala",
  "bisi bele bath powder": "bisi_bele_bath_masala",
  "bisibelebath masala": "bisi_bele_bath_masala",
  "bbb masala": "bisi_bele_bath_masala",
  "misal masala": "misal_masala",
  "misal pav masala": "misal_masala",
  "usal masala": "misal_masala",
  "misal spice mix": "misal_masala",
  "tea masala": "tea_masala",
  "chai masala": "tea_masala",
  "masala chai powder": "tea_masala",
  "chai ka masala": "tea_masala",
  "jaljeera powder": "jaljeera_powder",
  "jaljeera": "jaljeera_powder",
  "jal jeera": "jaljeera_powder",
  "jeera pani masala": "jaljeera_powder",
  "jaljira": "jaljeera_powder",
  "jal jira powder": "jaljeera_powder",
  "worcestershire sauce": "worcestershire_sauce",
  "worcestershire": "worcestershire_sauce",
  "worcester sauce": "worcestershire_sauce",
  "wustershire sauce": "worcestershire_sauce",
  "worchester sauce": "worcestershire_sauce",
  "tabasco sauce": "tabasco_sauce",
  "tabasco": "tabasco_sauce",
  "hot sauce": "tabasco_sauce",
  "tabasco hot sauce": "tabasco_sauce",
  "pepper sauce": "tabasco_sauce",
  "sriracha": "sriracha",
  "siracha": "sriracha",
  "sriracha sauce": "sriracha",
  "rooster sauce": "sriracha",
  "sriraja": "sriracha",
  "hoisin sauce": "hoisin_sauce",
  "hoisin": "hoisin_sauce",
  "chinese barbecue sauce": "hoisin_sauce",
  "hoi sin": "hoisin_sauce",
  "teriyaki sauce": "teriyaki_sauce",
  "teriyaki": "teriyaki_sauce",
  "teriyaki glaze": "teriyaki_sauce",
  "teri sauce": "teriyaki_sauce",
  "tahini": "tahini",
  "tahina": "tahini",
  "sesame paste": "tahini",
  "til paste": "tahini",
  "tahini paste": "tahini",
  "peanut butter": "peanut_butter",
  "groundnut butter": "peanut_butter",
  "moongphali butter": "peanut_butter",
  "pb": "peanut_butter",
  "fruit jam": "fruit_jam",
  "jam": "fruit_jam",
  "mixed fruit jam": "fruit_jam",
  "fruit preserve": "fruit_jam",
  "jaim": "fruit_jam",
  "strawberry jam": "fruit_jam",
  "marmalade": "marmalade",
  "orange marmalade": "marmalade",
  "citrus marmalade": "marmalade",
  "marmelade": "marmalade",
  "chocolate spread": "chocolate_spread",
  "nutella": "chocolate_spread",
  "hazelnut spread": "chocolate_spread",
  "choco spread": "chocolate_spread",
  "cocoa spread": "chocolate_spread",
  "kasundi mustard": "kasundi",
  "kasundi": "kasundi",
  "bengali mustard sauce": "kasundi",
  "kashundi": "kasundi",
  "mustard kasundi": "kasundi",
  "green chutney": "green_chutney",
  "hari chutney": "green_chutney",
  "dhaniya pudina chutney": "green_chutney",
  "coriander chutney": "green_chutney",
  "hari chatni": "green_chutney",
  "tamarind chutney": "tamarind_chutney",
  "imli chutney": "tamarind_chutney",
  "meethi chutney": "tamarind_chutney",
  "khajur imli chutney": "tamarind_chutney",
  "mint chutney": "mint_chutney",
  "pudina chutney": "mint_chutney",
  "pudhina chatni": "mint_chutney",
  "podina chutney": "mint_chutney",
  "coconut chutney": "coconut_chutney",
  "nariyal chutney": "coconut_chutney",
  "thengai chutney": "coconut_chutney",
  "kobbari chutney": "coconut_chutney",
  "thenga chutney": "coconut_chutney",
  "tomato chutney": "tomato_chutney",
  "tamatar chutney": "tomato_chutney",
  "thakkali chutney": "tomato_chutney",
  "tomato pachadi": "tomato_chutney",
  "garlic chutney": "garlic_chutney",
  "lehsun chutney": "garlic_chutney",
  "lasun chutney": "garlic_chutney",
  "poondu chutney": "garlic_chutney",
  "vellulli pachadi": "garlic_chutney",
  "capers": "capers",
  "caper berries": "capers",
  "kabra": "capers",
  "caper buds": "capers",
  "pesto": "pesto",
  "basil pesto": "pesto",
  "pesto genovese": "pesto",
  "pesto sauce": "pesto",
  "salsa": "salsa",
  "tomato salsa": "salsa",
  "mexican salsa": "salsa",
  "salsa dip": "salsa",
  "arrabbiata sauce": "arrabbiata_sauce",
  "arrabbiata": "arrabbiata_sauce",
  "arrabiata sauce": "arrabbiata_sauce",
  "spicy tomato pasta sauce": "arrabbiata_sauce",
  "arabiata": "arrabbiata_sauce",
  "pasta sauce": "pasta_sauce",
  "marinara": "pasta_sauce",
  "red pasta sauce": "pasta_sauce",
  "tomato pasta sauce": "pasta_sauce",
  "marinara sauce": "pasta_sauce",
  "pizza sauce": "pizza_sauce",
  "pizza base sauce": "pizza_sauce",
  "pizza tomato sauce": "pizza_sauce",
  "white sauce": "bechamel_base",
  "bechamel": "bechamel_base",
  "bechamel sauce": "bechamel_base",
  "white pasta sauce": "bechamel_base",
  "besciamella": "bechamel_base",
  "miso paste": "miso_paste",
  "miso": "miso_paste",
  "fermented soybean paste": "miso_paste",
  "white miso": "miso_paste",
  "red miso": "miso_paste",
  "shrimp paste": "shrimp_paste",
  "prawn paste": "shrimp_paste",
  "belacan": "shrimp_paste",
  "terasi": "shrimp_paste",
  "ngapi": "shrimp_paste",
  "thai red curry paste": "thai_red_curry_paste",
  "red curry paste": "thai_red_curry_paste",
  "red thai paste": "thai_red_curry_paste",
  "thai green curry paste": "thai_green_curry_paste",
  "green curry paste": "thai_green_curry_paste",
  "green thai paste": "thai_green_curry_paste",
  "harissa": "harissa",
  "harissa paste": "harissa",
  "north african chilli paste": "harissa",
  "harisa": "harissa",
  "gochujang": "gochujang",
  "korean chilli paste": "gochujang",
  "gochu jang": "gochujang",
  "red pepper paste": "gochujang",
  "ranch dressing": "ranch_dressing",
  "ranch": "ranch_dressing",
  "ranch dip": "ranch_dressing",
  "ranch sauce": "ranch_dressing",
  "thousand island dressing": "thousand_island_dressing",
  "thousand island": "thousand_island_dressing",
  "1000 island dressing": "thousand_island_dressing",
  "thousand island sauce": "thousand_island_dressing",
  "barbecue sauce": "barbecue_sauce",
  "bbq sauce": "barbecue_sauce",
  "bar b que sauce": "barbecue_sauce",
  "barbeque sauce": "barbecue_sauce",
  "honey mustard": "honey_mustard",
  "honey mustard sauce": "honey_mustard",
  "sweet mustard dressing": "honey_mustard",
  "dijon mustard": "dijon_mustard",
  "dijon": "dijon_mustard",
  "french mustard": "dijon_mustard",
  "dijon sauce": "dijon_mustard",
  "english mustard": "english_mustard",
  "hot mustard": "english_mustard",
  "yellow mustard paste": "english_mustard",
  "schezwan chutney": "schezwan_chutney",
  "schezwan paste": "schezwan_chutney",
  "szechuan chutney": "schezwan_chutney",
  "schezuan chutney": "schezwan_chutney",
  "manchurian sauce": "manchurian_sauce",
  "manchurian gravy base": "manchurian_sauce",
  "indo chinese sauce": "manchurian_sauce",
  "chilli garlic sauce": "chilli_garlic_sauce",
  "chili garlic sauce": "chilli_garlic_sauce",
  "garlic chilli sauce": "chilli_garlic_sauce",
  "lehsun mirch sauce": "chilli_garlic_sauce",
  "tartar sauce": "tartar_sauce",
  "tartare sauce": "tartar_sauce",
  "tarter sauce": "tartar_sauce",
  "onion paste": "onion_paste",
  "pyaz paste": "onion_paste",
  "fried onion paste": "onion_paste",
  "birista paste": "onion_paste",
  "kanda paste": "onion_paste",
  "cashew paste": "cashew_paste",
  "kaju paste": "cashew_paste",
  "kaju gravy base": "cashew_paste",
  "cashew nut paste": "cashew_paste",
  "red chilli paste": "red_chilli_paste",
  "lal mirch paste": "red_chilli_paste",
  "kashmiri chilli paste": "red_chilli_paste",
  "chilli paste": "red_chilli_paste",
  "garlic paste": "garlic_paste",
  "lehsun paste": "garlic_paste",
  "poondu paste": "garlic_paste",
  "velluli paste": "garlic_paste",
  "lasun paste": "garlic_paste",
  "ginger paste": "ginger_paste",
  "adrak paste": "ginger_paste",
  "inji paste": "ginger_paste",
  "shunti paste": "ginger_paste",
  "alla paste": "ginger_paste",
  "andhra avakaya paste": "avakaya_paste",
  "avakaya": "avakaya_paste",
  "avakai": "avakaya_paste",
  "andhra mango pickle": "avakaya_paste",
  "avakaya paste": "avakaya_paste",
  "mango thokku": "avakaya_paste",
  "matta rice": "matta_rice",
  "red rice": "matta_rice",
  "kerala red rice": "matta_rice",
  "rosematta rice": "matta_rice",
  "palakkadan matta": "matta_rice",
  "chemba rice": "matta_rice",
  "chethi rice": "matta_rice",
  "black rice": "black_rice",
  "forbidden rice": "black_rice",
  "chak hao": "black_rice",
  "kavuni arisi": "black_rice",
  "karuppu kavuni": "black_rice",
  "manipur black rice": "black_rice",
  "purple rice": "black_rice",
  "parboiled rice": "parboiled_rice",
  "sela rice": "parboiled_rice",
  "ukda chawal": "parboiled_rice",
  "puzhungal arisi": "parboiled_rice",
  "usna chawal": "parboiled_rice",
  "jasmine rice": "jasmine_rice",
  "thai fragrant rice": "jasmine_rice",
  "hom mali": "jasmine_rice",
  "chameli rice": "jasmine_rice",
  "arborio rice": "arborio_rice",
  "risotto rice": "arborio_rice",
  "italian short grain rice": "arborio_rice",
  "sticky rice": "sticky_rice",
  "glutinous rice": "sticky_rice",
  "sweet rice": "sticky_rice",
  "mochi rice": "sticky_rice",
  "thai sticky rice": "sticky_rice",
  "sona masoori rice": "sona_masoori_rice",
  "sona masuri": "sona_masoori_rice",
  "bangaru theegalu": "sona_masoori_rice",
  "sona mahsuri": "sona_masoori_rice",
  "medium grain rice": "sona_masoori_rice",
  "gobindobhog rice": "gobindobhog_rice",
  "gobindabhog": "gobindobhog_rice",
  "bengali aromatic rice": "gobindobhog_rice",
  "govind bhog": "gobindobhog_rice",
  "ambemohar rice": "ambemohar_rice",
  "ambe mohar": "ambemohar_rice",
  "maharashtra aromatic rice": "ambemohar_rice",
  "mango blossom rice": "ambemohar_rice",
  "barnyard millet": "barnyard_millet",
  "sanwa": "barnyard_millet",
  "samvat": "barnyard_millet",
  "sama": "barnyard_millet",
  "jhangora": "barnyard_millet",
  "oodalu": "barnyard_millet",
  "kuthiraivali": "barnyard_millet",
  "udalu": "barnyard_millet",
  "bhagar": "barnyard_millet",
  "vari": "barnyard_millet",
  "moraiyo": "barnyard_millet",
  "proso millet": "proso_millet",
  "chena": "proso_millet",
  "barri": "proso_millet",
  "baragu": "proso_millet",
  "panivaragu": "proso_millet",
  "variga": "proso_millet",
  "common millet": "proso_millet",
  "white millet": "proso_millet",
  "amaranth grain": "amaranth_grain",
  "rajgira": "amaranth_grain",
  "ramdana": "amaranth_grain",
  "chaulai seeds": "amaranth_grain",
  "keerai vidhai": "amaranth_grain",
  "thotakura ginjalu": "amaranth_grain",
  "amaranth seeds": "amaranth_grain",
  "buckwheat groats": "buckwheat_groats",
  "kuttu": "buckwheat_groats",
  "kotu": "buckwheat_groats",
  "papparai": "buckwheat_groats",
  "kaspat": "buckwheat_groats",
  "buckwheat whole": "buckwheat_groats",
  "kootu": "buckwheat_groats",
  "couscous": "couscous",
  "kuskus": "couscous",
  "moroccan couscous": "couscous",
  "semolina pasta": "couscous",
  "bulgur wheat": "bulgur_wheat",
  "bulghur": "bulgur_wheat",
  "burghul": "bulgur_wheat",
  "cracked wheat coarse": "bulgur_wheat",
  "polenta": "polenta",
  "coarse cornmeal": "polenta",
  "italian cornmeal": "polenta",
  "makki polenta": "polenta",
  "steel cut oats": "steel_cut_oats",
  "irish oats": "steel_cut_oats",
  "pinhead oats": "steel_cut_oats",
  "scotch oats": "steel_cut_oats",
  "coarse oats": "steel_cut_oats",
  "wheat bran": "wheat_bran",
  "chokar": "wheat_bran",
  "gehu chokar": "wheat_bran",
  "wheat chokar": "wheat_bran",
  "bran": "wheat_bran",
  "wheat germ": "wheat_germ",
  "gehu ankur": "wheat_germ",
  "wheat embryo": "wheat_germ",
  "freekeh": "freekeh",
  "farik": "freekeh",
  "green wheat": "freekeh",
  "roasted green wheat": "freekeh",
  "frikeh": "freekeh",
  "farro": "farro",
  "emmer wheat": "farro",
  "spelt farro": "farro",
  "italian farro": "farro",
  "wild rice": "wild_rice",
  "canadian rice": "wild_rice",
  "water oats": "wild_rice",
  "indian rice grass": "wild_rice",
  "jowar flakes": "jowar_flakes",
  "jowar poha": "jowar_flakes",
  "sorghum flakes": "jowar_flakes",
  "jola avalakki": "jowar_flakes",
  "pearl barley": "pearl_barley",
  "pearled barley": "pearl_barley",
  "barley pearls": "pearl_barley",
  "whole brown chana": "whole_brown_chana",
  "bhura chana": "whole_brown_chana",
  "desi chana": "whole_brown_chana",
  "brown chickpea": "whole_brown_chana",
  "kadale": "whole_brown_chana",
  "whole brown gram": "whole_brown_chana",
  "green chana": "green_chana",
  "hara chana": "green_chana",
  "chholiya": "green_chana",
  "green chickpea": "green_chana",
  "cholia": "green_chana",
  "hara cana": "green_chana",
  "dried green peas": "dried_green_peas",
  "sukhi matar": "dried_green_peas",
  "hara vatana": "dried_green_peas",
  "green vatana": "dried_green_peas",
  "dried matar": "dried_green_peas",
  "pachai pattani": "dried_green_peas",
  "white peas": "white_peas",
  "safed vatana": "white_peas",
  "safed matar": "white_peas",
  "white vatana": "white_peas",
  "ragda peas": "white_peas",
  "dried white peas": "white_peas",
  "yellow peas": "yellow_peas",
  "peeli matar": "yellow_peas",
  "yellow vatana": "yellow_peas",
  "split yellow peas": "yellow_peas",
  "whole soybean": "whole_soybean",
  "soya bean": "whole_soybean",
  "bhatmas": "whole_soybean",
  "soyabean whole": "whole_soybean",
  "yellow soybean": "whole_soybean",
  "soya": "whole_soybean",
  "black soybean": "black_soybean",
  "kala soyabean": "black_soybean",
  "black soya bean": "black_soybean",
  "kaala bhatmas": "black_soybean",
  "black soya": "black_soybean",
  "val dal": "val_dal",
  "vaal dal": "val_dal",
  "field beans split": "val_dal",
  "mochai paruppu": "val_dal",
  "split hyacinth bean": "val_dal",
  "whole val beans": "val_beans_whole",
  "vaal": "val_beans_whole",
  "hyacinth bean": "val_beans_whole",
  "chitra rajma": "chitra_rajma",
  "speckled kidney beans": "chitra_rajma",
  "chitkabra rajma": "chitra_rajma",
  "cranberry beans": "chitra_rajma",
  "jammu rajma": "chitra_rajma",
  "striped rajma": "chitra_rajma",
  "red rajma": "red_rajma",
  "lal rajma": "red_rajma",
  "dark red rajma": "red_rajma",
  "kashmiri rajma": "red_rajma",
  "white rajma": "white_rajma",
  "safed rajma": "white_rajma",
  "white kidney beans": "white_rajma",
  "cannellini beans": "white_rajma",
  "navy beans": "white_rajma",
  "adzuki beans": "adzuki_beans",
  "red mung": "adzuki_beans",
  "azuki": "adzuki_beans",
  "red chori": "adzuki_beans",
  "adzuki red beans": "adzuki_beans",
  "split brown chana": "black_chickpea_split",
  "kala chana dal": "black_chickpea_split",
  "desi chana dal": "black_chickpea_split",
  "brown chana split": "black_chickpea_split",
  "split desi gram": "black_chickpea_split",
  "split green peas": "green_peas_split",
  "matar dal": "green_peas_split",
  "split green matar": "green_peas_split",
  "hari matar dal": "green_peas_split",
  "green split peas": "green_peas_split",
  "red chori beans": "red_chori",
  "chawli red": "red_chori",
  "lal chori": "red_chori",
  "red rice beans": "red_chori",
  "chori dana": "red_chori",
  "sattu": "sattu",
  "roasted gram flour": "sattu",
  "chana sattu": "sattu",
  "bhuna chana atta": "sattu",
  "sattu flour": "sattu",
  "roasted bengal gram flour": "sattu",
  "multigrain atta": "multigrain_atta",
  "mixed grain flour": "multigrain_atta",
  "multgrain atta": "multigrain_atta",
  "saat anaj atta": "multigrain_atta",
  "multi grain flour": "multigrain_atta",
  "nutri atta": "multigrain_atta",
  "buckwheat flour": "kuttu_atta",
  "kuttu ka atta": "kuttu_atta",
  "kotu maavu": "kuttu_atta",
  "buckwheat atta": "kuttu_atta",
  "farali atta": "kuttu_atta",
  "kootu flour": "kuttu_atta",
  "water chestnut flour": "singhara_atta",
  "singhare ka atta": "singhara_atta",
  "singoda flour": "singhara_atta",
  "water chestnut atta": "singhara_atta",
  "paniphal flour": "singhara_atta",
  "singhada atta": "singhara_atta",
  "amaranth flour": "rajgira_flour",
  "rajgira atta": "rajgira_flour",
  "ramdana flour": "rajgira_flour",
  "chaulai atta": "rajgira_flour",
  "amaranth atta": "rajgira_flour",
  "rajgeera flour": "rajgira_flour",
  "almond flour": "almond_flour",
  "badam atta": "almond_flour",
  "badam powder": "almond_flour",
  "ground almonds": "almond_flour",
  "almond meal": "almond_flour",
  "badam flour": "almond_flour",
  "oat flour": "oat_flour",
  "jai atta": "oat_flour",
  "oats flour": "oat_flour",
  "ground oats": "oat_flour",
  "oats powder": "oat_flour",
  "coconut flour": "coconut_flour",
  "nariyal atta": "coconut_flour",
  "thengai maavu": "coconut_flour",
  "coconut powder flour": "coconut_flour",
  "kobbari flour": "coconut_flour",
  "soya flour": "soya_flour",
  "soybean flour": "soya_flour",
  "soya atta": "soya_flour",
  "soy flour": "soya_flour",
  "bhatmas flour": "soya_flour",
  "urad flour": "urad_flour",
  "urad dal flour": "urad_flour",
  "ulundu maavu": "urad_flour",
  "black gram flour": "urad_flour",
  "minapa pindi": "urad_flour",
  "urad atta": "urad_flour",
  "tapioca flour": "tapioca_flour",
  "tapioca starch": "tapioca_flour",
  "javvarisi maavu": "tapioca_flour",
  "sabudana flour": "tapioca_flour",
  "cassava flour": "tapioca_flour",
  "kappa flour": "tapioca_flour",
  "coarse semolina": "semolina_coarse",
  "bansi rava": "semolina_coarse",
  "mota rava": "semolina_coarse",
  "coarse sooji": "semolina_coarse",
  "bombay rava coarse": "semolina_coarse",
  "fine semolina": "semolina_fine",
  "fine sooji": "semolina_fine",
  "barik rava": "semolina_fine",
  "sanna rava": "semolina_fine",
  "vital wheat gluten": "vital_wheat_gluten",
  "wheat gluten": "vital_wheat_gluten",
  "gluten flour": "vital_wheat_gluten",
  "seitan flour": "vital_wheat_gluten",
  "gehu gluten": "vital_wheat_gluten",
  "roasted chickpea flour": "roasted_besan",
  "bhuna besan": "roasted_besan",
  "sekka besan": "roasted_besan",
  "roasted gram flour fine": "roasted_besan",
  "barley flour": "barley_flour",
  "jau atta": "barley_flour",
  "barley atta": "barley_flour",
  "jav flour": "barley_flour",
  "jau ka atta": "barley_flour",
  "fox nut flour": "makhana_flour",
  "makhana powder": "makhana_flour",
  "lotus seed flour": "makhana_flour",
  "phool makhana flour": "makhana_flour",
  "makhana atta": "makhana_flour",
  "banana flour": "banana_flour",
  "kele ka atta": "banana_flour",
  "raw banana flour": "banana_flour",
  "vazhakkai maavu": "banana_flour",
  "plantain flour": "banana_flour",
  "balekai hittu": "banana_flour",
  "sweet potato flour": "sweet_potato_flour",
  "shakarkandi atta": "sweet_potato_flour",
  "sakkarai valli maavu": "sweet_potato_flour",
  "sweet potato powder": "sweet_potato_flour",
  "foxtail millet flour": "foxtail_millet_flour",
  "kangni atta": "foxtail_millet_flour",
  "thinai maavu": "foxtail_millet_flour",
  "navane hittu": "foxtail_millet_flour",
  "korralu pindi": "foxtail_millet_flour",
  "foxtail millet atta": "foxtail_millet_flour",
  "kodo millet flour": "kodo_millet_flour",
  "kodra atta": "kodo_millet_flour",
  "varagu maavu": "kodo_millet_flour",
  "arikelu pindi": "kodo_millet_flour",
  "harka hittu": "kodo_millet_flour",
  "kodo flour": "kodo_millet_flour",
  "sago flour": "sago_flour",
  "sabudana atta": "sago_flour",
  "sabudana powder": "sago_flour",
  "javvarisi flour fine": "sago_flour",
  "sago starch": "sago_flour",
  "quinoa flour": "quinoa_flour",
  "quinoa atta": "quinoa_flour",
  "ground quinoa": "quinoa_flour",
  "quinoa powder": "quinoa_flour",
  "corn starch": "corn_starch",
  "cornflour fine": "corn_starch",
  "makki starch": "corn_starch",
  "corn flour starch": "corn_starch",
  "white corn starch": "corn_starch",
  "potato starch": "potato_starch",
  "aloo starch": "potato_starch",
  "potato flour starch": "potato_starch",
  "alu starch": "potato_starch",
  "arrowroot flour": "arrowroot_flour",
  "ararot": "arrowroot_flour",
  "arrowroot powder": "arrowroot_flour",
  "ararot atta": "arrowroot_flour",
  "koova podi": "arrowroot_flour",
  "jackfruit flour": "jackfruit_flour",
  "kathal atta": "jackfruit_flour",
  "raw jackfruit flour": "jackfruit_flour",
  "palakottai maavu": "jackfruit_flour",
  "green jackfruit flour": "jackfruit_flour",
  "skimmed milk": "skimmed_milk",
  "skim milk": "skimmed_milk",
  "fat free milk": "skimmed_milk",
  "double toned milk": "skimmed_milk",
  "patla doodh": "skimmed_milk",
  "full cream milk": "full_cream_milk",
  "whole milk": "full_cream_milk",
  "full fat milk": "full_cream_milk",
  "poora cream doodh": "full_cream_milk",
  "gaadha doodh": "full_cream_milk",
  "toned milk": "toned_milk",
  "toned doodh": "toned_milk",
  "single toned milk": "toned_milk",
  "a2 milk": "a2_milk",
  "a2 doodh": "a2_milk",
  "desi cow milk": "a2_milk",
  "gir cow milk": "a2_milk",
  "a2 desi milk": "a2_milk",
  "flavoured milk": "flavoured_milk",
  "flavored milk": "flavoured_milk",
  "badam milk": "flavoured_milk",
  "rose milk": "flavoured_milk",
  "kesar milk": "flavoured_milk",
  "milkshake milk": "flavoured_milk",
  "sour cream": "sour_cream",
  "khatti malai": "sour_cream",
  "cultured cream": "sour_cream",
  "double cream": "double_cream",
  "heavy cream": "double_cream",
  "whipping cream": "double_cream",
  "gaadhi malai": "double_cream",
  "single cream": "single_cream",
  "light cream": "single_cream",
  "cooking cream": "single_cream",
  "patli malai": "single_cream",
  "mozzarella": "mozzarella",
  "mozarella": "mozzarella",
  "pizza cheese": "mozzarella",
  "mozzarella cheese": "mozzarella",
  "cheddar": "cheddar",
  "cheddar cheese": "cheddar",
  "chedar": "cheddar",
  "parmesan": "parmesan",
  "parmesan cheese": "parmesan",
  "parmigiano": "parmesan",
  "parmesano": "parmesan",
  "processed cheese": "processed_cheese",
  "cheese slice": "processed_cheese",
  "cheese cube": "processed_cheese",
  "block cheese": "processed_cheese",
  "cheese spread": "cheese_spread",
  "creamy cheese spread": "cheese_spread",
  "feta": "feta",
  "feta cheese": "feta",
  "greek cheese": "feta",
  "ricotta": "ricotta",
  "ricotta cheese": "ricotta",
  "rikotta": "ricotta",
  "cream cheese": "cream_cheese",
  "philadelphia cheese": "cream_cheese",
  "burrata": "burrata",
  "burrata cheese": "burrata",
  "burata": "burrata",
  "gouda": "gouda",
  "gouda cheese": "gouda",
  "gauda": "gouda",
  "greek yogurt": "greek_yogurt",
  "greek yoghurt": "greek_yogurt",
  "greek curd": "greek_yogurt",
  "thick yogurt": "greek_yogurt",
  "hung curd": "hung_curd",
  "hung yogurt": "hung_curd",
  "chakka": "hung_curd",
  "strained curd": "hung_curd",
  "tanga hua dahi": "hung_curd",
  "flavoured yogurt": "flavoured_yogurt",
  "flavored yoghurt": "flavoured_yogurt",
  "fruit yogurt": "flavoured_yogurt",
  "mishti dahi": "flavoured_yogurt",
  "sweet curd": "flavoured_yogurt",
  "lassi": "lassi",
  "sweet lassi": "lassi",
  "salted lassi": "lassi",
  "chaas lassi": "lassi",
  "punjabi lassi": "lassi",
  "shrikhand": "shrikhand",
  "srikhand": "shrikhand",
  "amrakhand": "shrikhand",
  "evaporated milk": "evaporated_milk",
  "unsweetened condensed milk": "evaporated_milk",
  "ukala doodh": "evaporated_milk",
  "whey": "whey",
  "whey water": "whey",
  "paneer water": "whey",
  "chhena pani": "whey",
  "chhena": "chhena",
  "fresh curd cheese": "chhena",
  "rabri": "rabri",
  "rabdi": "rabri",
  "basundi": "rabri",
  "matha": "matha",
  "mattha": "matha",
  "spiced buttermilk": "matha",
  "duck egg": "duck_egg",
  "batak anda": "duck_egg",
  "duck anda": "duck_egg",
  "hans ka anda": "duck_egg",
  "quail egg": "quail_egg",
  "bater anda": "quail_egg",
  "bater ka anda": "quail_egg",
  "kaadai egg": "quail_egg",
  "quail anda": "quail_egg",
  "egg whites": "egg_whites",
  "egg white": "egg_whites",
  "liquid egg white": "egg_whites",
  "anda safedi": "egg_whites",
  "egg albumen": "egg_whites",
  "century egg": "century_egg",
  "preserved egg": "century_egg",
  "thousand year egg": "century_egg",
  "egg yolk": "egg_yolk",
  "anda peela": "egg_yolk",
  "yolk": "egg_yolk",
  "jordi": "egg_yolk",
  "country chicken": "country_chicken",
  "desi murgi": "country_chicken",
  "naati koli": "country_chicken",
  "nattu kozhi": "country_chicken",
  "country fowl": "country_chicken",
  "desi chicken": "country_chicken",
  "chicken sausage": "chicken_sausage",
  "murgi sausage": "chicken_sausage",
  "chicken franks": "chicken_sausage",
  "chicken salami": "chicken_salami",
  "murgi salami": "chicken_salami",
  "quail": "quail",
  "bater": "quail",
  "kaadai": "quail",
  "batair": "quail",
  "quail bird": "quail",
  "guinea fowl": "guinea_fowl",
  "chakor": "guinea_fowl",
  "chicken gizzard": "chicken_gizzard",
  "pott": "chicken_gizzard",
  "murgi gizzard": "chicken_gizzard",
  "chicken thigh": "chicken_thigh",
  "murgi jaangh": "chicken_thigh",
  "thigh meat": "chicken_thigh",
  "chicken ham": "chicken_ham",
  "murgi ham": "chicken_ham",
  "lamb": "lamb",
  "lamb meat": "lamb",
  "memna": "lamb",
  "raan": "lamb",
  "goat brain": "goat_brain",
  "bheja": "goat_brain",
  "bakri bheja": "goat_brain",
  "magaj": "goat_brain",
  "trotters": "trotters",
  "paya": "trotters",
  "khur": "trotters",
  "goat trotters": "trotters",
  "paaye": "trotters",
  "mutton chops": "mutton_chops",
  "champ": "mutton_chops",
  "mutton champ": "mutton_chops",
  "lamb chops": "lamb_chops",
  "lamb champ": "lamb_chops",
  "bacon": "bacon",
  "pork bacon": "bacon",
  "bekan": "bacon",
  "ham": "ham",
  "pork ham": "ham",
  "salami": "salami",
  "pork salami": "salami",
  "beef salami": "salami",
  "sausage": "sausage",
  "pork sausage": "sausage",
  "goan sausage": "sausage",
  "choris": "sausage",
  "sosej": "sausage",
  "pork ribs": "pork_ribs",
  "pork chaap": "pork_ribs",
  "suar ribs": "pork_ribs",
  "pork belly": "pork_belly",
  "suar pet": "pork_belly",
  "bacon belly": "pork_belly",
  "cold cuts": "cold_cuts",
  "deli meat": "cold_cuts",
  "sliced meat": "cold_cuts",
  "goat liver": "goat_liver",
  "bakri kaleji": "goat_liver",
  "goat kidney": "goat_kidney",
  "gurda": "goat_kidney",
  "kidney": "goat_kidney",
  "beef steak": "beef_steak",
  "steak": "beef_steak",
  "beef fillet": "beef_steak",
  "goat tongue": "goat_tongue",
  "zabaan": "goat_tongue",
  "jeebh": "goat_tongue",
  "kingfish": "surmai",
  "surmai": "surmai",
  "seer fish": "surmai",
  "seer": "surmai",
  "ney meen": "surmai",
  "anjal": "surmai",
  "vanjaram": "surmai",
  "gisada": "surmai",
  "hilsa": "hilsa",
  "ilish": "hilsa",
  "pulasa": "hilsa",
  "palla": "hilsa",
  "ilish maach": "hilsa",
  "bombay duck": "bombay_duck",
  "bombil": "bombay_duck",
  "bummalo": "bombay_duck",
  "boomla": "bombay_duck",
  "basa": "basa",
  "basa fish": "basa",
  "pangasius": "basa",
  "tilapia": "tilapia",
  "jalebi fish": "tilapia",
  "chilapi": "tilapia",
  "anchovy": "anchovy",
  "nethili": "anchovy",
  "mandeli": "anchovy",
  "kozhuva": "anchovy",
  "poravu": "anchovy",
  "thogai meen": "anchovy",
  "sole fish": "sole_fish",
  "repti": "sole_fish",
  "lep": "sole_fish",
  "nangu": "sole_fish",
  "red snapper": "snapper",
  "snapper": "snapper",
  "rane": "snapper",
  "sankara": "snapper",
  "chempalli": "snapper",
  "lobster": "lobster",
  "jhinga bada": "lobster",
  "istakoza": "lobster",
  "sea crayfish": "lobster",
  "mussels": "mussels",
  "kalva": "mussels",
  "shinaneo": "mussels",
  "kadukka": "mussels",
  "tisi": "mussels",
  "clams": "clams",
  "tisrya": "clams",
  "tisreo": "clams",
  "matti": "clams",
  "khube": "clams",
  "oyster": "oyster",
  "seep": "oyster",
  "muricha": "oyster",
  "scallops": "scallops",
  "sea scallop": "scallops",
  "dried fish": "dried_fish",
  "karuvadu": "dried_fish",
  "sukat": "dried_fish",
  "sukha machhi": "dried_fish",
  "bombil sukat": "dried_fish",
  "unakka meen": "dried_fish",
  "dried prawns": "dried_prawns",
  "sode": "dried_prawns",
  "sukat sode": "dried_prawns",
  "karuva eral": "dried_prawns",
  "unakka chemmeen": "dried_prawns",
  "fish roe": "fish_roe",
  "gaboli": "fish_roe",
  "machhli ke ande": "fish_roe",
  "fish eggs": "fish_roe",
  "octopus": "octopus",
  "neeli octopus": "octopus",
  "cuttlefish": "cuttlefish",
  "makul": "cuttlefish",
  "tiger prawns": "tiger_prawns",
  "kolambi": "tiger_prawns",
  "chingri bagda": "tiger_prawns",
  "jhinga tiger": "tiger_prawns",
  "catfish": "catfish",
  "singhara fish": "catfish",
  "tengra": "catfish",
  "keluthi": "catfish",
  "tengna": "catfish",
  "magur": "catfish",
  "pearl spot": "pearl_spot",
  "karimeen": "pearl_spot",
  "koral": "pearl_spot",
  "etroplus": "pearl_spot",
  "barramundi": "barramundi",
  "bhetki": "barramundi",
  "asian sea bass": "barramundi",
  "koduva": "barramundi",
  "pandugappa": "barramundi",
  "khajura": "barramundi",
  "eel": "eel",
  "baam machhli": "eel",
  "vilangu": "eel",
  "aaraal": "eel",
  "pecan": "pecan",
  "pecan nut": "pecan",
  "pecan nuts": "pecan",
  "pikan": "pecan",
  "macadamia": "macadamia",
  "macadamia nut": "macadamia",
  "makadamia": "macadamia",
  "queensland nut": "macadamia",
  "brazil nut": "brazil_nut",
  "brazil nuts": "brazil_nut",
  "brazilnut": "brazil_nut",
  "para nut": "brazil_nut",
  "chestnut": "chestnut",
  "chestnuts": "chestnut",
  "chest nut": "chestnut",
  "sweet chestnut": "chestnut",
  "betel nut": "betel_nut",
  "supari": "betel_nut",
  "areca nut": "betel_nut",
  "arecanut": "betel_nut",
  "pakku": "betel_nut",
  "adike": "betel_nut",
  "vakka": "betel_nut",
  "pophal": "betel_nut",
  "betelnut": "betel_nut",
  "mixed nuts": "mixed_nuts",
  "dry fruits mix": "mixed_nuts",
  "nut mix": "mixed_nuts",
  "assorted nuts": "mixed_nuts",
  "mixed dry fruits": "mixed_nuts",
  "hemp seeds": "hemp_seeds",
  "hemp seed": "hemp_seeds",
  "bhang beej": "hemp_seeds",
  "hemp hearts": "hemp_seeds",
  "hempseed": "hemp_seeds",
  "garden cress seeds": "garden_cress_seeds",
  "halim": "garden_cress_seeds",
  "aliv": "garden_cress_seeds",
  "aliv seeds": "garden_cress_seeds",
  "chandrashoor": "garden_cress_seeds",
  "allibeeja": "garden_cress_seeds",
  "halim seeds": "garden_cress_seeds",
  "gardencress": "garden_cress_seeds",
  "niger seed": "niger_seed",
  "niger seeds": "niger_seed",
  "ramtil": "niger_seed",
  "jagni": "niger_seed",
  "uchellu": "niger_seed",
  "gurellu": "niger_seed",
  "karale": "niger_seed",
  "nyger": "niger_seed",
  "canola oil": "canola_oil",
  "canola": "canola_oil",
  "rapeseed oil": "canola_oil",
  "kanola oil": "canola_oil",
  "palm oil": "palm_oil",
  "palmolein": "palm_oil",
  "palm olein": "palm_oil",
  "tad oil": "palm_oil",
  "palmoil": "palm_oil",
  "vegetable oil": "vegetable_oil",
  "veg oil": "vegetable_oil",
  "refined vegetable oil": "vegetable_oil",
  "refined oil": "refined_oil",
  "refined cooking oil": "refined_oil",
  "refined": "refined_oil",
  "filtered oil": "refined_oil",
  "flaxseed oil": "flaxseed_oil",
  "linseed oil": "flaxseed_oil",
  "alsi oil": "flaxseed_oil",
  "flax oil": "flaxseed_oil",
  "jawas oil": "flaxseed_oil",
  "avocado oil": "avocado_oil",
  "avacado oil": "avocado_oil",
  "avocadooil": "avocado_oil",
  "lard": "lard",
  "pig fat": "lard",
  "cooking lard": "lard",
  "margarine": "margarine",
  "margerine": "margarine",
  "table margarine": "margarine",
  "marjarine": "margarine",
  "cooking spray": "cooking_spray",
  "oil spray": "cooking_spray",
  "non stick spray": "cooking_spray",
  "cooking oil spray": "cooking_spray",
  "stevia": "stevia",
  "stevia leaf": "stevia",
  "steviya": "stevia",
  "meethi tulsi": "stevia",
  "stevia powder": "stevia",
  "sugar substitute": "sugar_free",
  "sugar free": "sugar_free",
  "sugarfree": "sugar_free",
  "artificial sweetener": "sugar_free",
  "sucralose": "sugar_free",
  "aspartame": "sugar_free",
  "corn syrup": "corn_syrup",
  "cornsyrup": "corn_syrup",
  "glucose syrup corn": "corn_syrup",
  "high fructose corn syrup": "corn_syrup",
  "hfcs": "corn_syrup",
  "golden syrup": "golden_syrup",
  "goldensyrup": "golden_syrup",
  "light treacle": "golden_syrup",
  "cane syrup": "golden_syrup",
  "glucose": "glucose",
  "glucose powder": "glucose",
  "dextrose": "glucose",
  "glucon": "glucose",
  "liquid glucose": "glucose",
  "glukos": "glucose",
  "fructose": "fructose",
  "fruit sugar": "fructose",
  "fructose powder": "fructose",
  "fruktose": "fructose",
  "molasses": "molasses",
  "sheera": "molasses",
  "kakvi": "molasses",
  "black treacle": "molasses",
  "ras": "molasses",
  "molases": "molasses",
  "gud sheera": "molasses",
  "date syrup": "date_syrup",
  "khajur syrup": "date_syrup",
  "date honey": "date_syrup",
  "dates syrup": "date_syrup",
  "khajoor syrup": "date_syrup",
  "agave syrup": "agave",
  "agave nectar": "agave",
  "agava": "agave",
  "khandsari sugar": "khandsari",
  "khandsari": "khandsari",
  "khand": "khandsari",
  "desi sugar": "khandsari",
  "unrefined sugar": "khandsari",
  "cream of tartar": "cream_of_tartar",
  "tartaric acid": "cream_of_tartar",
  "potassium bitartrate": "cream_of_tartar",
  "creamoftartar": "cream_of_tartar",
  "marzipan": "marzipan",
  "almond paste": "marzipan",
  "marzapan": "marzipan",
  "marzipane": "marzipan",
  "white chocolate": "white_chocolate",
  "white choco": "white_chocolate",
  "whitechocolate": "white_chocolate",
  "white chocolate bar": "white_chocolate",
  "sprinkles": "sprinkles",
  "hundreds and thousands": "sprinkles",
  "sugar sprinkles": "sprinkles",
  "jimmies": "sprinkles",
  "cake sprinkles": "sprinkles",
  "whipped cream powder": "whipped_cream_powder",
  "whip cream powder": "whipped_cream_powder",
  "whipping cream powder": "whipped_cream_powder",
  "whipped cream mix": "whipped_cream_powder",
  "self raising flour": "self_raising_flour",
  "self rising flour": "self_raising_flour",
  "selfraising flour": "self_raising_flour",
  "self raised flour": "self_raising_flour",
  "dough conditioner": "dough_conditioner",
  "bread improver": "dough_conditioner",
  "dough improver": "dough_conditioner",
  "bread conditioner": "dough_conditioner",
  "jelly crystals": "jelly_crystals",
  "jelly powder": "jelly_crystals",
  "jelly mix": "jelly_crystals",
  "jelly crystal": "jelly_crystals",
  "bread crumbs": "bread_crumbs",
  "breadcrumbs": "bread_crumbs",
  "bread crumb": "bread_crumbs",
  "crumbs": "bread_crumbs",
  "panko": "bread_crumbs",
  "soft drink": "cold_drink",
  "cold drink": "cold_drink",
  "aerated drink": "cold_drink",
  "cola": "cold_drink",
  "fizzy drink": "cold_drink",
  "cold drinks": "cold_drink",
  "energy drink": "energy_drink",
  "energy drinks": "energy_drink",
  "red bull": "energy_drink",
  "sports drink": "energy_drink",
  "lemonade mix": "lemonade_mix",
  "nimbu pani mix": "lemonade_mix",
  "shikanji mix": "lemonade_mix",
  "lemonade powder": "lemonade_mix",
  "lemon drink mix": "lemonade_mix",
  "squash concentrate": "squash",
  "rooh afza": "squash",
  "fruit squash": "squash",
  "sharbat concentrate": "squash",
  "rose squash": "squash",
  "orange squash": "squash",
  "sherbet": "sherbet",
  "sharbat": "sherbet",
  "sherbat": "sherbet",
  "sarbat": "sherbet",
  "sherbet concentrate": "sherbet",
  "kombucha": "kombucha",
  "kambucha": "kombucha",
  "fermented tea": "kombucha",
  "kombuchaa": "kombucha",
  "soy milk": "soy_milk",
  "soya milk": "soy_milk",
  "soymilk": "soy_milk",
  "soybean milk": "soy_milk",
  "almond milk": "almond_milk",
  "almondmilk": "almond_milk",
  "badam doodh": "almond_milk",
  "oat milk": "oat_milk",
  "oats milk": "oat_milk",
  "oatmilk": "oat_milk",
  "herbal tea": "herbal_tea",
  "herbal chai": "herbal_tea",
  "tisane": "herbal_tea",
  "ayurvedic tea": "herbal_tea",
  "lemon tea": "lemon_tea",
  "nimbu chai": "lemon_tea",
  "lemon chai": "lemon_tea",
  "lemon tea bag": "lemon_tea",
  "iced tea": "ice_tea",
  "ice tea": "ice_tea",
  "ice tea mix": "ice_tea",
  "cold tea": "ice_tea",
  "beer": "beer",
  "lager": "beer",
  "ale": "beer",
  "cooking beer": "beer",
  "biyar": "beer",
  "wine": "wine",
  "red wine": "wine",
  "white wine": "wine",
  "cooking wine grape": "wine",
  "waine": "wine",
  "rum": "rum",
  "dark rum": "rum",
  "white rum": "rum",
  "cooking rum": "rum",
  "vodka": "vodka",
  "vodca": "vodka",
  "cooking vodka": "vodka",
  "wodka": "vodka",
  "whisky": "whisky",
  "whiskey": "whisky",
  "scotch": "whisky",
  "cooking whisky": "whisky",
  "wiski": "whisky",
  "cooking wine": "cooking_wine",
  "rice wine": "cooking_wine",
  "mirin": "cooking_wine",
  "shaoxing wine": "cooking_wine",
  "culinary wine": "cooking_wine",
  "chips": "chips",
  "wafers": "chips",
  "potato chips": "chips",
  "aloo chips": "chips",
  "crisps": "chips",
  "chip": "chips",
  "namkeen": "namkeen",
  "mixture": "namkeen",
  "namkin": "namkeen",
  "farsan": "namkeen",
  "savoury mix": "namkeen",
  "chiwda": "namkeen",
  "sev": "sev",
  "sev namkeen": "sev",
  "nylon sev": "sev",
  "besan sev": "sev",
  "sev bhujia": "sev",
  "bhujia": "bhujia",
  "bhujiya": "bhujia",
  "aloo bhujia": "bhujia",
  "bikaneri bhujia": "bhujia",
  "popcorn": "popcorn",
  "pop corn": "popcorn",
  "makka popcorn": "popcorn",
  "corn pop": "popcorn",
  "butter popcorn": "popcorn",
  "instant soup": "instant_soup",
  "soup mix": "instant_soup",
  "cup soup": "instant_soup",
  "ready soup": "instant_soup",
  "packet soup": "instant_soup",
  "ready to eat meal": "ready_to_eat",
  "ready to eat": "ready_to_eat",
  "rte": "ready_to_eat",
  "instant meal": "ready_to_eat",
  "ready meal": "ready_to_eat",
  "frozen vegetables": "frozen_veg",
  "frozen veg": "frozen_veg",
  "mixed frozen vegetables": "frozen_veg",
  "frozen mix veg": "frozen_veg",
  "frozen paratha": "frozen_paratha",
  "frozen parantha": "frozen_paratha",
  "ready paratha": "frozen_paratha",
  "frozen parotta": "frozen_paratha",
  "frozen fries": "frozen_fries",
  "french fries": "frozen_fries",
  "frozen french fries": "frozen_fries",
  "finger chips frozen": "frozen_fries",
  "gravy mix": "gravy_mix",
  "ready gravy": "gravy_mix",
  "curry base": "gravy_mix",
  "gravy paste": "gravy_mix",
  "instant gravy": "gravy_mix",
  "stock cube": "stock_cube",
  "bouillon": "stock_cube",
  "bouillon cube": "stock_cube",
  "vegetable bouillon": "stock_cube",
  "maggi cube": "stock_cube",
  "vegetable stock": "vegetable_stock",
  "veg stock": "vegetable_stock",
  "vegetable broth": "vegetable_stock",
  "veg broth": "vegetable_stock",
  "chicken stock": "chicken_stock",
  "chicken broth": "chicken_stock",
  "chicken bouillon": "chicken_stock",
  "murgh stock": "chicken_stock",
  "gelatin sheets": "gelatin_sheets",
  "leaf gelatin": "gelatin_sheets",
  "gelatine sheets": "gelatin_sheets",
  "gelatin leaf": "gelatin_sheets",
  "burger bun": "burger_bun",
  "burger buns": "burger_bun",
  "sesame bun": "burger_bun",
  "brioche bun": "burger_bun",
  "pizza base": "pizza_base",
  "pizza crust": "pizza_base",
  "pizza bread": "pizza_base",
  "ready pizza base": "pizza_base",
  "tortilla": "tortilla",
  "wrap": "tortilla",
  "tortilla wrap": "tortilla",
  "flour tortilla": "tortilla",
  "nachos": "nachos",
  "nacho chips": "nachos",
  "tortilla chips": "nachos",
  "naachos": "nachos",
  "instant idli mix": "instant_idli_mix",
  "idli mix": "instant_idli_mix",
  "ready idli mix": "instant_idli_mix",
  "instant idli": "instant_idli_mix",
  "dosa mix": "dosa_mix",
  "instant dosa mix": "dosa_mix",
  "ready dosa mix": "dosa_mix",
  "dosa batter mix": "dosa_mix",
  "gulab jamun mix": "gulab_jamun_mix",
  "gulab jamun ready mix": "gulab_jamun_mix",
  "jamun mix": "gulab_jamun_mix",
  "instant gulab jamun": "gulab_jamun_mix",
  "jelly": "jelly",
  "jelly dessert": "jelly",
  "fruit jelly": "jelly",
  "jelly cubes": "jelly",
  "ice cream": "ice_cream",
  "icecream": "ice_cream",
  "kulfi": "ice_cream",
  "ice cream tub": "ice_cream",
  "frozen momos": "frozen_momos",
  "frozen momo": "frozen_momos",
  "ready momos": "frozen_momos",
  "frozen dumplings": "frozen_momos",
  "meetha attar": "meetha_attar",
  "meetha ittar": "meetha_attar",
  "food attar": "meetha_attar",
  "kewra attar": "meetha_attar",
  "sweet attar": "meetha_attar",
  "ittar": "meetha_attar",
  "edible camphor": "edible_camphor",
  "camphor": "edible_camphor",
  "kapur": "edible_camphor",
  "pachai karpooram": "edible_camphor",
  "edible kapoor": "edible_camphor",
  "bhimseni kapur": "edible_camphor",
  "betel leaf": "betel_leaf",
  "paan": "betel_leaf",
  "paan leaf": "betel_leaf",
  "vethalai": "betel_leaf",
  "tamalapaku": "betel_leaf",
  "nagavalli": "betel_leaf",
  "beeda leaf": "betel_leaf",
  "supari mix": "supari_mix",
  "mouth freshener": "supari_mix",
  "mukhwas": "supari_mix",
  "sweet supari": "supari_mix",
  "paan masala mix": "supari_mix",
  "alum": "alum",
  "phitkari": "alum",
  "fitkari": "alum",
  "patika": "alum",
  "alum stone": "alum",
  "sphatika": "alum",
  "slaked lime": "slaked_lime",
  "chuna": "slaked_lime",
  "choona": "slaked_lime",
  "edible lime": "slaked_lime",
  "calcium hydroxide": "slaked_lime",
  "sunna": "slaked_lime",
  "noon": "slaked_lime",
  "dough": "dough",
  "atta dough": "dough",
  "gundha atta": "dough",
  "kneaded dough": "dough",
  "maida dough": "dough",
  "banana leaf": "banana_leaf",
  "kela patta": "banana_leaf",
  "vazhai ilai": "banana_leaf",
  "baale yele": "banana_leaf",
  "arati aaku": "banana_leaf",
  "plantain leaf": "banana_leaf",
  "bathua": "bathua",
  "bathua leaves": "bathua",
  "bathua saag": "bathua",
  "chenopodium": "bathua",
  "pigweed": "bathua",
  "chakvat": "bathua",
  "turkey berry": "turkey_berry",
  "sundakkai": "turkey_berry",
  "sundaikkai": "turkey_berry",
  "sundakka": "turkey_berry",
  "dried turkey berry": "turkey_berry",
  "manathakkali": "turkey_berry",
  "boondi": "boondi",
  "besan boondi": "boondi",
  "plain boondi": "boondi",
  "namkeen boondi": "boondi",
  "bassaru powder": "bassaru_powder",
  "bassaru masala": "bassaru_powder",
  "bassaru spice mix": "bassaru_powder",
  "gojju powder": "gojju_powder",
  "gojju masala": "gojju_powder",
  "gojju spice mix": "gojju_powder",
  "vangi bhaat masala": "vangi_bhaat_masala",
  "vangibhath masala": "vangi_bhaat_masala",
  "caesar dressing": "caesar_dressing",
  "caesar sauce": "caesar_dressing",
  "caesar salad dressing": "caesar_dressing",
  "croutons": "croutons",
  "bread croutons": "croutons",
  "toasted bread cubes": "croutons",
};

export function resolveIngredientImageId(
  name?: string | null,
  ingredientId?: string | null,
): string | null {
  const id = ingredientId?.trim();
  if (id) return id;
  const key = normalizeIngredientName(name ?? '');
  return key ? INGREDIENT_NAME_TO_ID[key] ?? null : null;
}
